let CERT_COLUMN;
let CLASS_COLUMN;
let stringOptions;
let sharesOwned = 0;
let builtGiftTransferModalAlready;
let addedGiftTransferListenersAlready;

function giftTransfer (shareholder, fromUser) {
	/* NOTES
	This method creates the Gift / Transfer modal
	For each class, it gets relevant data for the active user
	The resultant display can be filtered by class
	*/

	if (userData.userid == "consolidated.view" || shareholderData.userid == "consolidated.view") {
		userData = JSON.parse(sessionStorage.getItem("shareholder.Data"));
		shareholder = userData.userid;
		shareholderData = userData;
	}
	let currentHeadline = document.getElementById("giftHeadline").innerText;
	currentHeadline = currentHeadline.replace("From:", '').trim();
	if (currentHeadline && currentHeadline != userData.user_name) {
		builtGiftTransferModalAlready = false;
		sharesOwned = 0;
	}

	if (builtGiftTransferModalAlready) return;
	builtGiftTransferModalAlready = true;

	let members;
	let allGifts = [];
	let ttlBasis = 0;
	let ttlAfter = 0;
	let ttlBefore = 0;
	let pairedQty = 0;
	let selectedClass;
	let minDiff = 999;	// arbitrarily large starting number used in tranche analysis
	let diffCount = 0;	// counter used in tranche analysis
	let removeGiftId = "";
	let giftRecipients = [];
	let priorTransfers = [];
	let includedClasses = [];
	let giftTransactions = [];
	let historicHoldings = [];
	let origTransactions = [];
	let selectedTranches = [];
	let toggle = "Show Positves";

	let giftUserData = shareholderData;
	let giftUserId = giftUserData.userid;

	const BUY_BACK = pn == '/' && clientData.flags?.buy_back_active;
	const viewGiftTransferModal = document.getElementById('viewGiftTransferModal');
	const userGiftTransferTable = document.getElementById('userGiftTransferTable');

	// Need to wait for external data
	clientData = JSON.parse(sessionStorage.getItem(client + '.Data'));

	// Build a new transactions list
	let classes = Object.keys(clientData.equity);
	if (classes.length > 1) CLASS_COLUMN = true;
	classes.sort();

	classes.forEach((c, i) => {
		// console.log(clientData.equity[c].transactions)
		let classIncluded = false;
		// Try looking at Transactions first, then Approved balances
		let classTransactions = clientData.equity[c].transactions || [];
		classTransactions.forEach(function (t) {
			if ((t.receiver && t.receiver.toLowerCase() == shareholder) || (t.sender && t.sender.toLowerCase() == shareholder)) {
				t.shareClass = classes[i];
				giftTransactions.push(t);
				classIncluded = true;
			}
		});
		CERT_COLUMN ||= classTransactions.some(t => t.notes.includes('#'));

		// Dont't display future (beyond this year) Events or Transactions
		let nextYear = new Date(new Date().getFullYear() + 1, 1, 1) / 1000;
		giftTransactions = giftTransactions.filter(t => Number(t.date) < nextYear);
		console.log("initialTransactions[" + c + "]: ", giftTransactions);

		let userShares = giftUserData.clients[client].shares[c];
		if (classIncluded) includedClasses.push(c);
		//clientEvents = clientEvents.concat(clientData.equity[c].events);

		let shareholderClientData = shareholderData.clients[client];
		let userTransactions = classTransactions.filter(t => t.receiver == shareholder || t.sender == shareholder);
		if (userTransactions.length && shareholderClientData.shares[c]) {
			// Need to rationalize, or at least say, Owned vs Approved
			sharesOwned += Number(shareholderClientData.shares[c].approved);
		}
	});

	let ttlCurrentValue = "n.a.";
	let balanceBefore = sharesOwned;
	let balanceAfter = balanceBefore;
	// let shortName = giftUserData.clients[client].notes;

	let trancheLog = localStorage.getItem('TrancheLog');
	trancheLog += "\n" + "Shares Owned: " + balanceBefore;
	localStorage.setItem('TrancheLog', trancheLog);

	const giftHeadline = document.getElementById('giftHeadline');
	const balanceHeadline = document.getElementById('balanceHeadline');
	const stepwiseAnalysis = document.getElementById('stepwiseAnalysis');
	const giftTransferControls = document.getElementById('giftTransferControls');
	if (!sharesOwned || stepwiseAnalysis?.checked) giftTransferControls.classList.add('hidden');
	else giftTransferControls.classList.remove('hidden');
	giftHeadline.innerHTML = `From:&ensp;<span class="text-light">` + giftUserData.user_name + `</span>`;
	// giftHeadline.innerHTML = `From:&ensp;<span class="text-light">` + (shortName ? shortName + " | " : "") + giftUserData.user_name + `</span>`;
	balanceHeadline.innerHTML = 'Shares Owned Now:&emsp;<span class="text-primary">' + balanceBefore.toLocaleString('en-US', customFormat()) +
		`</span>&nbsp;Before&emsp;<span id="balanceAfterElem" class="text-primary${balanceAfter.after < 0 ? ' red-text font-bold' : ''}">` + balanceAfter.toLocaleString('en-US', customFormat()) + `</span>&nbsp;After`;

	// SEE NOTES HERE: https://docs.google.com/document/d/1tASR37WcKOE-x_LJKlCy0JhD0g0cWPaTUCUPNAlRjNE/edit
	// First, sort all transactions chronologically, oldest to newest.
	// Next, scan for dates with multiple transactions.
	// Each of these dates must be analyzed separately for possible splits or related swaps.
	// In all cases, cost basis must be carried forward.

	// Determine if these transactions share the current account as both sender and receiver.
	// If all go only in one direction (single-leg) these transactions require no special treatment.

	// If the transactions go in opposite directions, start by sorting all of the transactions for a given date by descending dollar amounts.

	// Now look for matching quantities (swaps).
	// Do the total aggregate quantities in each direction match?
	// If not, do any individual quantities in each direction match?
	// If not, does any individual quantity match a group of opposite quantities?

	// If matching quantities are not found, look for matching dollar amounts (splits).
	// Do the total aggregate dollar amounts in each direction match?
	// If not, do any individual dollar amounts in each direction match?
	// If not, does any individual amount match a group of opposite amounts?
	// If any matches are found, determine and enter the new post-split cost basis.
	// Filter out first leg (cancellation) of stock swaps and stock splits.

	// No clue why, but we need new array objects...
	giftTransactions = JSON.parse(JSON.stringify(giftTransactions));

	// --- Stepwise: clamp giftTransactions to cutoff date  ---
	(function () {
		// build sorted unique list of all dates
		let allDates = Array.from(new Set(giftTransactions.map(t => String(t.date))))
			.sort((a, b) => Number(a) - Number(b));

		// master and target length
		window._stepwiseMasterLen = allDates.length;
		if (window._stepwiseTargetLen == null) window._stepwiseTargetLen = _stepwiseMasterLen;

		// clamp target length
		if (_stepwiseMasterLen === 0) {
			window._stepwiseTargetLen = 0;
		} else {
			if (_stepwiseTargetLen < 1) _stepwiseTargetLen = 1;
			if (_stepwiseTargetLen > _stepwiseMasterLen) _stepwiseTargetLen = _stepwiseMasterLen;
		}

		// cutoff date = last visible date
		const cutoffSec = _stepwiseTargetLen > 0 ? Number(allDates[_stepwiseTargetLen - 1]) : 0;

		// filter giftTransactions IN PLACE
		if (cutoffSec > 0) {
			giftTransactions = giftTransactions.filter(t => Number(t.date) <= cutoffSec);
		}

		// optional: update label/buttons
		const label = document.getElementById('stepLabel');
		if (label) {
			if (_stepwiseTargetLen === 0) {
				label.textContent = "As of --/--/-- (0 of 0)";
			} else {
				const ms = cutoffSec * 1000;
				const dstr = window.moment ? moment(ms).format("MM/DD/YY") : new Date(ms).toLocaleDateString();
				label.textContent = `As of ${dstr} (${_stepwiseTargetLen} of ${_stepwiseMasterLen})`;
			}
		}
	})();

	function reduceToVestedOnly() {
		const userid = giftUserData.userid;
		const shareClasses = giftUserData.clients?.[client]?.shares || {};
		const grants = [];

		// Loop over all share classes
		for (const [classKey, classData] of Object.entries(shareClasses)) {
			const vestingData = classData.vesting || {};

			// Build array of structured grant data
			for (const [grantName, grant] of Object.entries(vestingData)) {
				const schedule = grant.schedule || {};
				const timestamps = Object.keys(schedule).map(t => Number(t));
				const total = timestamps.reduce((sum, t) => sum + Number(schedule[t].amount || 0), 0);
				const vested = timestamps
					.filter(t => schedule[t].posted)
					.reduce((sum, t) => sum + Number(schedule[t].amount || 0), 0);

				// Extract a grant date from the title, e.g., "1/1/24"
				const dateMatch = grantName.match(/(\d{1,2}\/\d{1,2}\/\d{2,4})/);
				let titleDateStr = null;
				if (dateMatch) titleDateStr = dateMatch[1];

				grants.push({ grantName, total, vested, titleDateStr, classKey });
			}
		}

		// Adjust the transactions
		for (const tx of giftTransactions) {
			if (
				tx.notes.toLowerCase().includes("restricted stock grant") &&
				tx.receiver === userid
			) {
				const txQty = Number(tx.quantity);
				const txDate = Number(tx.date);
				const txClass = tx.shareClass;

				// Format transaction date as "m/d/yy" and "m/d/yyyy"
				const txDateStr = new Date(txDate * 1000).toLocaleDateString('en-US');
				const [m, d, y] = txDateStr.split('/');
				const altYear = y.length === 4 ? y.slice(2) : '20' + y;
				const altDateStr = `${m}/${d}/${altYear}`;

				// Match against grants
				const match = grants.find(grant =>
					grant.total === txQty &&
					grant.classKey === txClass &&
					grant.titleDateStr &&
					(grant.titleDateStr === txDateStr || grant.titleDateStr === altDateStr)
				);

				if (match) {
					tx.quantity = match.vested.toString(); // even if 0
				}
			}
		}
	}

	// too early for historical context
	// if (isEDM) reduceToVestedOnly();

	giftTransactions.sort((a, b) => Number(a.date) - Number(b.date));
	origTransactions = JSON.parse(JSON.stringify(giftTransactions));

	// normalize all dates to midnight of that date
	giftTransactions.forEach(t => t.date && (t.date = moment.unix(t.date).startOf('day').unix()));

	// For each Recieve from company with no sharePrice, insert latest valuation or assumed price
	// giftTransactions.forEach(r => {
	// 	if (r.receiver == giftUserId && (r.sender == "" || r.sender == client || r.senderName.toLowerCase() == "issuer"))
	// 		r.sharePrice = toNumber(r.sharePrice).toString();
	// 		let classValuations = clientData.equity[r.shareClass].valuations.sort((a, b) => Number(a.date) - Number(b.date));
	// 		let nearestValuation = null;
	// 		for (const valuation of classValuations) {
	// 			if (Number(valuation.date) > Number(r.date)) break;
	// 			nearestValuation = valuation;
	// 		}
	// 		if (nearestValuation) r.sharePrice = nearestValuation.sharePrice;
	// });

	// On first pass, go class-by-class.  May need to revisit with mixed classes for swaps.
	classes.forEach(c => {

		// First, find dates with multiple transations on the same date
		let transactionsDateCount = giftTransactions.filter(g => g.shareClass == c).reduce((t, r) => {
			t[r.date] = (t[r.date] || 0) + 1;
			return t;
		}, {});
		let multipleSameDates = Object.keys(transactionsDateCount).filter(date => transactionsDateCount[date] >= 1);
		multipleSameDates.push(Math.floor(Date.now() / 1000).toString());  // add today to catch any recent single sends.
		multipleSameDates.sort((a, b) => Number(a) - Number(b));
		console.log("multipleSameDates[" + c + "]: ", multipleSameDates);

		let carryOverDeduct = 0;

		// Now, examine each of these dates, starting with the oldest one
		multipleSameDates.forEach(function(d) {

			console.log("### SAME DATE ###: ", moment.unix(d).format('DD-MMM-YY'))

			// First handle any earlier single Send that occurs on a given date by itself
			let singleSendTransactions = giftTransactions.filter(g => sameClassAndSender(g) && earlierDate(g));
			singleSendTransactions.forEach(singleSend => {
				let targetQty = Number(singleSend.quantity);
				if (handleDescriptionMatch(singleSend, targetQty, Number(singleSend.date))) {
					console.log("DESCRIPTION MATCH Transaction: ", singleSend);
					singleSend.tranche = c + "-" + singleSend.date;
					priorTransfers.push(singleSend);
					giftTransactions = giftTransactions.filter(g => g.nrid != singleSend.nrid);
				} else if (handlePerfectFit(singleSend, targetQty, Number(singleSend.date) - 43200, false)) {		// 1/2 day
					console.log("SINGLE SEND Transaction: ", singleSend);
					singleSend.tranche = c + "-" + singleSend.date;
					priorTransfers.push(singleSend);
					giftTransactions = giftTransactions.filter(g => g.nrid != singleSend.nrid);
				} else if (handlePerfectFit(singleSend, targetQty, Number(singleSend.date), false)) {
					console.log("SINGLE SEND Transaction: ", singleSend);
					singleSend.tranche = c + "-" + singleSend.date;
					priorTransfers.push(singleSend);
					giftTransactions = giftTransactions.filter(g => g.nrid != singleSend.nrid);
				} else {
					console.log("*** NO SEND-ONLY MATCH ***");
					let safety = 0;
					let firstHistoric;
					while (targetQty > 0 && safety < 20) {
						safety++;
						let firstPrior = giftTransactions.slice().reverse().find(g => sameClassAndReceiver(g) && Number(g.date) <= Number(singleSend.date));
						if (firstPrior && firstPrior.quantity > targetQty) {
							firstPrior.quantity = (Number(firstPrior.quantity) - targetQty).toString();
							firstHistoric = JSON.parse(JSON.stringify(firstPrior));
							firstHistoric.quantity = targetQty.toString();
							firstHistoric.tranche = c + "-" + singleSend.date;
							historicHoldings.push(firstHistoric);
							targetQty = 0;
						} else {
							targetQty -= Number(firstPrior.quantity);
							firstPrior.tranche = c + "-" + singleSend.date;
							historicHoldings.push(firstPrior);
							giftTransactions = giftTransactions.filter(g => g.nrid != firstPrior.nrid);
						}
					}
					console.log("SINGLE SEND Transaction: ", singleSend);
					singleSend.tranche = c + "-" + singleSend.date;
					priorTransfers.push(singleSend);
					giftTransactions = giftTransactions.filter(g => g.nrid != singleSend.nrid);
				}
			});

			// Next look for same day cancel/reissue (e.g. lost certificate)
			let sameDateTransactions = giftTransactions.filter(t => t.date == d && t.shareClass == c);
			let sameDateSends = sameDateTransactions.filter(t => t.sender == giftUserId);
			let sameDateReceives = sameDateTransactions.filter(t => t.receiver == giftUserId);
			if (isEDM && sameDateSends.length && sameDateReceives.length >= 1) releaseRestrictedEquity(sameDateTransactions);
			if (sameDateSends.length) cancelReissueCertificate(sameDateTransactions);

			// Next, more complex scenarios
			sameDateTransactions = giftTransactions.filter(t => t.date == d && t.shareClass == c);
			sameDateTransactions.sort((a, b) => Number(b.quantity) - Number(a.quantity));
			sameDateSends = sameDateTransactions.filter(t => t.sender == giftUserId);
			sameDateReceives = sameDateTransactions.filter(t => t.receiver == giftUserId);
			let sameDateSenders = [...new Set(sameDateTransactions.map(t => t.sender))];
			let sameDateReceivers = [...new Set(sameDateTransactions.map(t => t.receiver))];
			let sameDateSendQtySum = sameDateSends.reduce((a, b) => a + Number(b.quantity), 0);
			let sameDateReceiveQtySum = sameDateReceives.reduce((a, b) => a + Number(b.quantity), 0);
			let sameDateSendAmtSum = sameDateSends.reduce((a, b) => a + (Number(b.quantity) * toNumber(b.sharePrice)), 0);
			let sameDateReceiveAmtSum = sameDateReceives.reduce((a, b) => a + (Number(b.quantity) * toNumber(b.sharePrice)), 0);
			let sameDateNetQty = Math.abs(sameDateSendQtySum - sameDateReceiveQtySum);
			let sameDateNetAmt = Math.abs(sameDateSendAmtSum - sameDateReceiveAmtSum);
			// console.log("sameDate: ", d);
			// console.log("sameDateTrans: ", sameDateTransactions);
			// console.log("Senders: ", sameDateSenders);
			// console.log("Receivers: ", sameDateReceivers);
			// console.log("Sends: ", sameDateSends);
			// console.log("Receives: ", sameDateReceives);
			// console.log("SendQtySum: ", sameDateSendQtySum);
			// console.log("ReceiveQtySum: ", sameDateReceiveQtySum);
			// console.log("SendAmtSum: ", sameDateSendAmtSum);
			// console.log("ReceiveAmtSum: ", sameDateReceiveAmtSum);

			let isSwapOrSplit = false;
			if (sameDateSends.length == 0) {
				// ONE WAY recieve transactions - do nothing
				console.log("ONE-WAY Receiving: ", sameDateReceives);
			} else if (sameDateReceives.length == 0) {
				// ONE WAY send transactions - look for matches
				console.log("ONE-WAY Sending: ", sameDateSends);

				// First try finding old certificates, where each exactly matches one of the Sends
				let exactMatches = oneForOneMatches(sameDateSends);
				if (exactMatches) return;

				// Attempt 1 - first look for one prior Receive that exactly matches the collection of Sends
				let exactMatchTrans = giftTransactions.find(g => sameClassAndReceiver(g) && earlierDate(g) && sameQty(g, sameDateSendQtySum));
				if (exactMatchTrans) {
					let sendTransactions = giftTransactions.filter(g => sameClassAndSender(g) && sameDate(g));
					sendTransactions.forEach(s => s.tranche = c + "-" + d);
					priorTransfers = priorTransfers.concat(sendTransactions);
					console.log("SEND Transactions: ", sendTransactions);
					giftTransactions = giftTransactions.filter(g => !sameClassAndSender(g) || !sameDate(g));
					giftTransactions = giftTransactions.filter(g => g.nrid != exactMatchTrans.nrid);
					exactMatchTrans.tranche = c + "-" + d;
					historicHoldings.push(exactMatchTrans);
				} else {
					// Need to tear things apart, Send by Send
					let closeMatchTrans;
					sameDateSends.forEach(s => {
						// Attempt 2 & 3 -Try to find one or more prior Receives that match this Send
						exactMatchTrans = giftTransactions.find(g => sameClassAndReceiver(g) && earlierDate(g) && sameQty(g, Number(s.quantity)) && (notRestricted(g) || !isEDM));
						if (exactMatchTrans || !parseTransfers()) {
							let sendTransaction = giftTransactions.filter(g => g.nrid == s.nrid)[0];
							if (!sendTransaction) return;
							sendTransaction.tranche = c + "-" + d;
							priorTransfers.push(sendTransaction);
							giftTransactions = giftTransactions.filter(g => g.nrid != s.nrid);
							if (exactMatchTrans) {	// <- Good, a simple solution, all done (Attempt 2)
								giftTransactions = giftTransactions.filter(g => g.nrid != exactMatchTrans.nrid);
								exactMatchTrans.tranche = c + "-" + d;
								historicHoldings.push(exactMatchTrans);
							} else if (!closeMatchTrans) {	// <- Need to score "open" prior Receives to find the best one (Attempt 3 & 4)
								let openTransactions = giftTransactions.filter(g => sameClassAndReceiver(g) && earlierDate(g) && !g.tranche && (notRestricted(g) || !isEDM));
								if (openTransactions.length) {
									// After finding the closest match, clone this Receive as a "Twin" and move on to the next Send for this date
									closeMatchTrans = scoreMatches(sendTransaction, openTransactions);
									console.log("CLOSE Match: ", closeMatchTrans);
									if (closeMatchTrans) {
										// need new object
										closeMatchTrans = JSON.parse(JSON.stringify(closeMatchTrans));
										// giftTransactions = giftTransactions.filter(g => g.nrid != bestMatchTrans.nrid);
										closeMatchTrans.tranche = c + "-" + d;
										if (!closeMatchTrans.before) closeMatchTrans.before = closeMatchTrans.quantity;
										closeMatchTrans.quantity = s.quantity;
										historicHoldings.push(closeMatchTrans);
									}
								}
							}
						}
						// For a close match (not exact), deduct the from the "Twin" the quantity of every Send
						if (closeMatchTrans) {
							let matchTwin = giftTransactions.find(h => h.nrid == closeMatchTrans.nrid);
							if (!matchTwin.before) matchTwin.before = Number(matchTwin.quantity);
							matchTwin.quantity = Number(matchTwin.quantity) - Number(s.quantity);
							if (carryOverDeduct) {
								matchTwin.quantity += carryOverDeduct;
								carryOverDeduct = 0;
							}
							if (matchTwin.quantity < 0) {
								carryOverDeduct = matchTwin.quantity;
								matchTwin.quantity = 0;
							}
							matchTwin.quantity = matchTwin.quantity.toString();
						}
						closeMatchTrans = null;		// reset
					});
				}
			} else if (sameDateReceivers.length < 3 && (sameDateNetQty < 0.1 || sameDateNetAmt < 0.1)) {
				if (sameDateNetQty < 0.1) {
					if (sameDateSenders.sort().toString() != sameDateReceivers.sort().toString()) {
						// Attempt 1 - it's a TRANSFER
						let uniqueSenders = sameDateSenders.filter(u => !sameDateReceivers.includes(u));
						let uniqueReceivers = sameDateReceivers.filter(u => !sameDateSenders.includes(u));
						console.log("TRANSFER Transactions: ", uniqueSenders.concat(uniqueReceivers));
					}
					// Attempt 1 - it's a SWAP
					isSwapOrSplit = true;
					parseTransfers();
				} else if (sameDateNetAmt < 0.1) {
						// Attempt 2 - it's a SPLIT
					isSwapOrSplit = true;
					parseTransfers();
				}
			} else {
				// Attempt 2 - it might be a Vermeer-style reissue transfer
				// Look for a pair transaction with the issuer (equal quantity, cancellation/re-issue)
				pairedQty = 0;
				let exactMatch = false;
				// Remove active certificates - NO!!
				// sameDateSends = sameDateSends.filter(s => !s.notes.includes("#"));
				sameDateSends.forEach(send => {
					sameDateReceives.forEach(receive => {
						if (Number(send.quantity) == Number(receive.quantity)) pairedQty += Number(receive.quantity);
					});
				});

				// First try finding old certificates, where each quantity exactly matches one of the Sends
				if (pairedQty && !exactMatch) exactMatch = oneForOneMatches(sameDateSends);

				// Next try to find one old certificate that is an exact match for the collection of Sends
				let exactMatchTrans = giftTransactions.find(g => sameClassAndReceiver(g) && earlierDate(g) && sameQty(g, sameDateSendQtySum));
				if (exactMatchTrans) {
					giftTransactions = giftTransactions.filter(g => g.nrid != exactMatchTrans.nrid);
					exactMatchTrans.tranche = c + "-" + d;
					historicHoldings.push(exactMatchTrans);
					// Remove all of the associated send transactions
					let sendTransactions = giftTransactions.filter(g => sameClassAndSender(g) && thisDateOrEarlier(g));
					sendTransactions.forEach(s => s.tranche = c + "-" + d);
					sendTransactions.forEach(adjTrans => {
						if (isNaN(adjTrans.sharePrice)) {
							adjTrans.sharePrice = exactMatchTrans.sharePrice;
							console.log("ADJUSTED Transaction: ", adjTrans);
						}
					});
					priorTransfers = priorTransfers.concat(sendTransactions);
					console.log("SEND Transactions: ", sendTransactions);
					giftTransactions = giftTransactions.filter(g => !sameClassAndSender(g) || !thisDateOrEarlier(g));
					sameDateReceives.forEach(adjTrans => {
						if (isNaN(adjTrans.sharePrice)) {
							adjTrans.sharePrice = exactMatchTrans.sharePrice;
							console.log("ADJUSTED Transaction: ", adjTrans);
						}
					});
					exactMatch = true;
				}

				// If that fails, start rolling up old certificates using stub logic below
				if (pairedQty && !exactMatch) parseTransfers();

				// It's not a Vermeer-style reissue...
				if (!pairedQty && sameDateReceives.length == 1 && sameDateSends.length > 1) {
					// If net sending (no STUB), bail out.  Not sure how to handle if mult-legged....
					if (sameDateReceiveAmtSum > sameDateSendAmtSum + 1) {
						console.log("NET Receive Amount: ", sameDateReceiveAmtSum - sameDateSendAmtSum);
					}
					// It's a STUB
					console.log("NET Send Amount: ", sameDateSendAmtSum - sameDateReceiveAmtSum);
					parseTransfers();
				}

				// Finally look for cancel/reissue certificate number
				canceledCertificate(sameDateSends);
			}

			function releaseRestrictedEquity (sameDaySends) {
				console.log("Begining sameDateSends: ", sameDaySends);
				// First try finding certificates, where each exactly matches one of the Sends
				let nonMatch;
				let matchCount = 0;
				sameDaySends.forEach(send => {
					if (!toIssuer(send)) return;
					console.log("This Send: ", send);
					let exactMatches = giftTransactions.filter(g => send.nrid != g.nrid && send.quantity == g.quantity && sameClassAndReceiver(g) && sameDate(g) && sameCertificate(g.notes, send.notes));
					let exactMatch = !exactMatches ? null : exactMatches.length == 1 ? exactMatches[0] : scoreMatches(send, exactMatches);
					console.log("Very close match: ", exactMatch);
					if (exactMatch) {
						let sendQty = Number(send.quantity);
						let otherSends = giftTransactions.filter(g => send.nrid != g.nrid && sameClassAndSender(g) && sameDate(g) && !isReleaseLike(g));
						console.log("Other sends: ", otherSends);
						let otherSend = otherSends.length == 1 ? otherSends[0] : scoreDifferences(send, otherSends);
						let otherSendQty = otherSend ? Number(otherSend.quantity) : 0;
						// if (otherSends.length) otherSendQty = otherSends.reduce((sum, g) => sum + Number(g.quantity), 0);

						// Get the other receive tranche, the non-match
						let nonMatches = giftTransactions.filter(g => g.nrid !== exactMatch.nrid && sameClassAndReceiver(g) && thisDateOrEarlier(g) && Number(g.quantity) >= sendQty);
						if (nonMatches?.length) {
							// handle the nonMatch as new object
							nonMatch = JSON.parse(JSON.stringify(nonMatches.length == 1 ? nonMatches[0] : scoreDifferences(send, nonMatches)));
							let nonMatchQty = Number(nonMatch.quantity);
							// If excess quantity, split the NON MATCH. otherwise remove the NON MATCH from current gift transactions
							if (nonMatchQty < sendQty || otherSendQty > sendQty) return false;
							else {
								let origNonMatch = giftTransactions.find(g => g.nrid == nonMatch.nrid);
								origNonMatch.quantity = (nonMatchQty - sendQty).toString();
								send.quantity = (sendQty - otherSendQty).toString();
								exactMatch.quantity = send.quantity;
							}

							nonMatch.quantity = sendQty.toString();
							nonMatch.tranche =  c + "-" + d;
							historicHoldings.push(nonMatch);

							matchCount++;
							processSendTransaction(send);
							// if (otherSends.length) otherSends.forEach(processSendTransaction);
							if (otherSend) processSendTransaction(otherSend);
						}
					};
				});
				console.log("Ending sameDateSends: ", sameDaySends);
				return matchCount > 0;

				function processSendTransaction(g) {
					g.tranche = c + "-" + d;

					// Remove from giftTransactions
					giftTransactions = giftTransactions.filter(x => x.nrid !== g.nrid);

					// Adjust sharePrice if missing
					if (isNaN(g.sharePrice)) {
						g.sharePrice = nonMatch?.sharePrice;
						console.log("ADJUSTED Transaction: ", g);
					}

					// Add to priorTransfers
					priorTransfers = priorTransfers.concat(g);
					console.log("SEND Transaction: ", g);

					// Remove from sameDateSends
					sameDateSends = sameDateSends.filter(s => s.nrid !== g.nrid);
				}
			}

			function cancelReissueCertificate (sameDateSends) {
				console.log("sameDateSends: ", sameDateSends);
				// First try finding certificates, where each exactly matches one of the Sends
				let matchCount = 0;
				sameDateSends.forEach(send => {
					if (!toIssuer(send)) return;
					console.log("This Send: ", send);
					let exactMatches = giftTransactions.filter(g => send.nrid != g.nrid && send.quantity == g.quantity && sameClassAndReceiver(g) && sameDate(g) && sameCertificate(g.notes, send.notes));
					let exactMatch = !exactMatches ? null : exactMatches.length == 1 ? exactMatches[0] : scoreMatches(send, exactMatches);
					console.log("SAME Certificate: ", exactMatch);
					if (exactMatch) {
						matchCount++;
						send.tranche = c + "-" + d;
						// Remove the SEND from current gift transactions
						giftTransactions = giftTransactions.filter(g => g.nrid != send.nrid);
						let matches = giftTransactions.filter(g => send.nrid != g.nrid && send.quantity == g.quantity && sameClassAndReceiver(g) && sameDate(g) && sameCertificate(g.notes, send.notes));
						if (matches.length) {	// there should only be one match, alert otherwise??
							let match = matches.length == 1 ? matches[0] : scoreMatches(send, matches);
							match.tranche = c + "-" + d;
							// Add the MATCH to historic holdings
							historicHoldings.push(match);
							// Remove the MATCH from current gift transactions
							giftTransactions = giftTransactions.filter(g => g.nrid != match.nrid);
							if (isNaN(send.sharePrice)) {
								send.sharePrice = match.sharePrice;
								console.log("ADJUSTED Transaction: ", send);
							}
							// Add the SEND to prior transfers
							priorTransfers = priorTransfers.concat(send);
							console.log("SEND Transaction: ", send);
						}
					};
				});
				return matchCount > 0;
			}

			function canceledCertificate (sameDateSends) {
				// First try finding old certificates, where each exactly matches one of the Sends
				let matchCount = 0;
				sameDateSends.forEach(send => {
					let exactMatches = giftTransactions.filter(g => send.quantity == g.quantity && sameClassAndReceiver(g) && earlierDate(g) && sameCertificate(g.notes, send.notes));
					let exactMatch = !exactMatches ? null : exactMatches.length == 1 ? exactMatches[0] : scoreMatches(send, exactMatches);
					console.log("SAME Certificate: ", exactMatch);
					if (exactMatch) {
						matchCount++;
						sameDateSends.forEach(s => {
							s.tranche = c + "-" + d;
							giftTransactions = giftTransactions.filter(g => g.nrid != s.nrid);
							let matches = giftTransactions.filter(g => sameClassAndReceiver(g) && earlierDate(g) && sameCertificate(g.notes, s.notes));
							if (matches.length) {	// there should only be one match, alert otherwise??
								let match = matches.length == 1 ? matches[0] : scoreMatches(s, matches);
								match.tranche = c + "-" + d;
								historicHoldings.push(match);
								giftTransactions = giftTransactions.filter(g => g.nrid != match.nrid);
								if (isNaN(s.sharePrice)) {
									s.sharePrice = match.sharePrice;
									console.log("ADJUSTED Transaction: ", s);
								}
							} else {
								// handle same-day single-send after (after consolidation?)
								let exactMatches = giftTransactions.filter(g => s.quantity == g.quantity && sameClassAndReceiver(g) && sameDate(g) && sameCertificate(g.notes, s.notes));
								let exactMatch = !exactMatches ? null : exactMatches.length == 1 ? exactMatches[0] : scoreMatches(s, exactMatches);
								console.log("SAME Certificate: ", exactMatch);
								if (exactMatch) {
									s.tranche = c + "-" + d;
									giftTransactions = giftTransactions.filter(g => g.nrid != s.nrid);
									let matches = giftTransactions.filter(g => sameClassAndReceiver(g) && sameDate(g) && sameCertificate(g.notes, s.notes));
									if (matches.length) {	// there should only be one match, alert otherwise??
										let match = matches.length == 1 ? matches[0] : scoreMatches(s, matches);
										match.tranche = c + "-" + d;
										historicHoldings.push(match);
										giftTransactions = giftTransactions.filter(g => g.nrid != match.nrid);
										if (isNaN(s.sharePrice)) {
											s.sharePrice = match.sharePrice;
											console.log("ADJUSTED Transaction: ", s);
										}
									}
								};
							}
						});
						priorTransfers = priorTransfers.concat(sameDateSends);
						console.log("SEND Transactions: ", sameDateSends);
					};
				});
				return matchCount > 0;
			}

			function oneForOneMatches (sameDateSends) {
				// First try finding old certificates, where each exactly matches one of the Sends
				let matchCount = 0;
				// need clone of giftTransactions to handle potential duplicate quantities
				let giftClone = JSON.parse(JSON.stringify(giftTransactions));
				if (isEDM) giftClone = giftClone.filter(g => notRestricted(g));
				sameDateSends.forEach(send => {
					let exactMatches = giftClone.filter(g => !activeCertificate(g) && sameClassAndReceiver(g) && earlierDate(g) && sameQty(g, Number(send.quantity)));
					let exactMatch = !exactMatches ? null : exactMatches.length == 1 ? exactMatches[0] : scoreMatches(send, exactMatches);
					console.log("EXACT Match: ", exactMatch);
					if (exactMatch) {
						giftClone = giftClone.filter(g => g.nrid != exactMatch.nrid);
						matchCount++;
					}
				});
				if (matchCount == sameDateSends.length) {
					sameDateSends.forEach(s => {
						s.tranche = c + "-" + d;
						giftTransactions = giftTransactions.filter(g => g.nrid != s.nrid);
						let matches = giftTransactions.filter(g => !activeCertificate(g) && sameClassAndReceiver(g) && earlierDate(g) && sameQty(g, Number(s.quantity)));
						if (matches.length) {
							let match = matches.length == 1 ? matches[0] : scoreMatches(s, matches);
							match.tranche = c + "-" + d;
							historicHoldings.push(match);
							giftTransactions = giftTransactions.filter(g => g.nrid != match.nrid);
							if (isNaN(s.sharePrice)) {
								s.sharePrice = match.sharePrice;
								console.log("ADJUSTED Transaction: ", s);
							}
						}
					});
					priorTransfers = priorTransfers.concat(sameDateSends);
					console.log("SEND Transactions: ", sameDateSends);
					return true;
				}
				return false;
			}

			// This method identifies the best combination of Prior Receives to match a collection of Sends
			// It also handles swaps and splits, if identified
			function parseTransfers() {
				let splitRatio = 1;
				if (isSwapOrSplit) {
					splitRatio = sameDateReceiveQtySum / sameDateSendQtySum;
					console.log("SPLIT Ratio: ", splitRatio);
				}
				// If stub, get stub info
				let stubs = sameDateTransactions.filter(b => b.receiver == giftUserId);
				// let stubMatches = sameDateTransactions.filter(m => sameClassAndSender(m));
				let stubMatches = giftTransactions.filter(m => sameClassAndSender(m) && sameDate(m));
				// Remove active certificates - Maybe...
				// stubMatches = stubMatches.filter(s => !s.notes.includes("#"));
				console.log("STUB Transactions: ", stubs);
				console.log("STUB Matches: ", stubMatches);

				// For each re-issue, remove the returned cert(s)
				// Find matching old cert(s), and calculate cost basis
				// Move old cert(s) to Prior list

				let foundGroupFit;
				let priorGrossQty = stubMatches.reduce((a, b) => a + Number(b.quantity), 0);
				let priorGrossCost = stubMatches.reduce((a, b) => a + (Number(b.quantity) * toNumber(b.sharePrice)), 0);
				let newPrice = priorGrossQty ? priorGrossCost / priorGrossQty : 0;
				console.log("PRIOR grossQty = " + priorGrossQty);
				console.log("PRIOR grossCost = " + priorGrossCost);
				console.log("NEW price = " + newPrice);
				if (!sameDateReceives.length) {
					// Look for perfect match
					// find and remove the prior receive transaction(s) that sum to targetQty
					let priorTrans = giftTransactions.filter(g => thisDateOrEarlier(g) && sameClassAndReceiver(g));
					// Remove active certificates
					priorTrans = priorTrans.filter(p => !p.notes.includes("#"));
					priorTrans.sort((a, b) => (Number(a.date) > Number(b.date)) ? -1 : 1);	// newest to oldest
					priorTrans.sort((a, b) => Number(b.quantity) - Number(a.quantity));		// largest to smallest
					console.log("PRIOR Transactions: ", priorTrans);
					minDiff = 999;	// reset arbitrarily large starting number used in tranche analysis
					let perfectFit = findSubset(priorGrossQty, priorTrans);
					if (perfectFit) {
						foundGroupFit = true;
						console.log("PERFECT Fit: ", perfectFit);
						perfectFit.forEach(p => p.tranche = c + "-" + d);
						historicHoldings = historicHoldings.concat(perfectFit);
						let perfectNrids = new Set(perfectFit.map(item => item.nrid));
						giftTransactions = giftTransactions.filter(g => !perfectNrids.has(g.nrid));
						priorGrossQty = perfectFit.reduce((acc, val) => acc + Number(val.quantity), 0);
						priorGrossCost = perfectFit.reduce((acc, val) => acc + (Number(val.quantity) * toNumber(val.sharePrice)), 0);
					} else console.log("no further fit");

					// let thisTransaction = giftTransactions.find(g => g.nrid == trans.nrid);
					// if (thisTransaction) thisTransaction.sharePrice = (priorGrossCost / (isSwapOrSplit ? Number(thisTransaction.quantity) : priorGrossQty)).toString();
					// console.log("ADJUSTED Transaction: ", thisTransaction);
					// return perfectFit ? true : false;
				} else {
					let totalReceived = 0;
					let targetQuantity = priorGrossQty * splitRatio;
					sameDateReceives.forEach(receiveTran => {
						if (foundGroupFit && totalReceived >= targetQuantity) return;
						// if (foundGroupFit) return; <-- FAILS with Walt at Mazzetti
						if (isSwapOrSplit) {
							priorGrossQty = Number(receiveTran.quantity) / splitRatio;
							console.log("SPLIT grossQty = " + priorGrossQty);
						}
						if (handlePerfectFit(receiveTran, priorGrossQty, Number(d), isSwapOrSplit)) {
							totalReceived += Number(receiveTran.quantity);
							console.log("TOTAL received = " + totalReceived);
							receiveTran.tranche = c + "-" + d;
							foundGroupFit = true;
						}
					});
				}
				if (foundGroupFit) {
					// remove all of the associated send transactions
					// let sendTransactions = giftTransactions.filter(g => sameClassAndSender(g) && thisDateOrEarlier(g));
					let sendTransactions = giftTransactions.filter(g => sameClassAndSender(g) && sameDate(g));
					let sendSum = sendTransactions.reduce((a, b) => a + Number(b.quantity), 0);
					console.log("PRIOR GrossQty = " + priorGrossQty, " SEND Sum = " + sendSum);
					// if (sendSum < priorGrossQty) sendTransactions = giftTransactions.filter(g => sameClassAndSender(g) && thisDateOrEarlier(g));
					sendTransactions.forEach(s => s.tranche = c + "-" + d);
					priorTransfers = priorTransfers.concat(sendTransactions);
					console.log("SEND Transactions: ", sendTransactions);
					// giftTransactions = giftTransactions.filter(g => !sameClassAndSender(g) || !thisDateOrEarlier(g));
					giftTransactions = giftTransactions.filter(g => !sameClassAndSender(g) || !sameDate(g));

					// remove all of the associated receive transactions
					sameDateReceives.forEach(adjTrans => {
						// adjTrans.tranche = c + "-" + d;
						// adjTrans.sharePrice = newPrice.toString();
						console.log("ADJUSTED Transaction: ", adjTrans);
						// giftTransactions = giftTransactions.filter(g => g.nrid != adjTrans.nrid);
					});
					// historicHoldings = historicHoldings.concat(sameDateReceives);
				}
				return foundGroupFit ? true : false;
			}

			// Utility functions
			function toIssuer (trans) { return (trans.receiver == client || trans.receiver.toLowerCase() == "issuer" || trans.receiverName.toLowerCase() == "issuer"); }
			function fromIssuer (trans) { return (trans.sender == client || trans.sender.toLowerCase() == "issuer" || trans.senderName.toLowerCase() == "issuer"); }
			function activeCertificate (trans) { return /\(.*?#.*?\)/.test(trans.notes); }
			function thisDateOrEarlier (trans) { return Number(trans.date) <= Number(d); }
			function earlierDate (trans) { return Number(trans.date) < Number(d); }
			function sameDate (trans) { return Number(trans.date) == Number(d); }
			function sameQty (trans, qty) { return Number(trans.quantity) == qty; }
			function sameCertificate (transNotes, notes) {
				console.log("transNotes", transNotes)
				console.log("notes", notes)
				if (!CERT_COLUMN) return areSimilar(transNotes, notes);
				// console.log("transNotes", (transNotes.match(/\(([^)]*?(\d+)[^)]*?)\)/) || [])[2])
				// console.log("notes", (notes.match(/\(([^)]*?(\d+)[^)]*?)\)/) || [])[2])
				// return (transNotes.match(/\((\d+)\)/) || [])[1] == (notes.match(/\((\d+)\)/) || [])[1];
				if ((transNotes.match(/\(([^)]*?(\d+)[^)]*?)\)/) || [])[2] == (notes.match(/\(([^)]*?(\d+)[^)]*?)\)/) || [])[2]) {
					console.log("***MATCH***");
					return true;
				} else return false;
			}
			function areSimilar(a, b) {
				const setA = new Set(a.toLowerCase());
				const setB = new Set(b.toLowerCase());
				const overlap = [...setA].filter(c => setB.has(c)).length;
				const avgLen = (setA.size + setB.size) / 2;
				return overlap / avgLen > 0.6; // tweak threshold as needed
			}
			function isReleaseLike (trans) {
				const s = trans.notes;
				if (!s) return false;
				const t = s.toLowerCase();
				// specific phrase first
				if (/release\s+of\s+unvested\s+shares\s+granted/.test(t)) return true;
				// broader release signal
				if (t.includes('release') && (t.includes('unvested') || t.includes('restricted'))) return true;
				return false;
			}

			// Check historicHoldings for negative quantities
			historicHoldings.forEach((h, i) => {
				if (Number(h.quantity) < 0) {
					alert(`Negative quantity in historicHoldings[${i}]:`, h);
				}
			});

			// Check giftTransactions for negative quantities
			giftTransactions.forEach((g, i) => {
				if (Number(g.quantity) < 0) {
					alert(`Negative quantity in giftTransactions[${i}]:`, g);
				}
			});
		});

		function allocateCarryOver() {
			let remaining = -carryOverDeduct; // Make positive for internal logic
			while (remaining > 0.0001) {
				// Step 1: get valid candidates with quantity > 0
				const candidates = giftTransactions
					.filter(gt => {
						const qty = Number(gt.quantity);
						return !isNaN(qty) && qty > 0;
					});

				// Step 2: pick tranche already being reduced
				let target = candidates.find(gt => Number(gt.before) > Number(gt.quantity));

				// Step 3: otherwise pick by lowest price + oldest date
				if (!target) {
					candidates.sort((a, b) => {
						const priceA = Number(a.sharePrice) || Infinity;
						const priceB = Number(b.sharePrice) || Infinity;
						if (priceA !== priceB) return priceA - priceB;
						return (a.date || 0) - (b.date || 0);
					});
					target = candidates[0];
				}

				if (!target) break; // Nothing valid left

				// Initialize .before if not already set
				if (target.before == null) target.before = Number(target.quantity);

				const qty = Number(target.quantity);
				const deductNow = Math.min(remaining, qty);

				target.quantity = (qty - deductNow).toFixed(6).replace(/\.?0+$/, '');
				remaining -= deductNow;
			}
		}

		// Must account for any remaining carryOverDeduct
		if (carryOverDeduct) allocateCarryOver();

		// For Edmund Optics, never include RSGs or Awards
		if (isEDM) giftTransactions = giftTransactions.filter(g => notRestricted(g));
		// reduceToVestedOnly();

		// Simple test logic
		// if (carryOverDeduct) {
		// 	if (!giftTransactions[1].before) giftTransactions[1].before = giftTransactions[1].quantity;
		// 	giftTransactions[1].quantity = (Number(giftTransactions[1].quantity) + carryOverDeduct).toString();
		// }

		// console.log("postSwapTransactions: ", giftTransactions);

		// This method looks for a prior transaction specified precisely in the send description
		function handleDescriptionMatch (trans, targetQty, date) {
			let priorTrans = giftTransactions.filter(g => Number(g.date) <= date && Number(g.quantity) >= targetQty && sameClassAndReceiver(g));
			let notesMatch = findNotesMatch(trans.notes, priorTrans); // <- single OBJECT or false

			if (notesMatch) {
				console.log("NOTES MATCH: ", notesMatch);

				const priorGrossQty = Number(notesMatch.quantity) || 0;
				const consumeQty = Math.min(Number(targetQty) || 0, priorGrossQty);

				// Clone BEFORE pushing so we don't mutate the pushed reference
				const trancheItem = {
					...notesMatch,
					tranche: c + "-" + trans.date,
					quantity: consumeQty.toString()
				};
				// Immutable List -> reassign
				historicHoldings.push(trancheItem);

				// Update/remove the ORIGINAL in giftTransactions
				const remaining = priorGrossQty - consumeQty;
				if (remaining <= 0) {
					giftTransactions = giftTransactions.filter(g => g.nrid != notesMatch.nrid);
				} else {
					const idx = giftTransactions.findIndex(g => g.nrid == notesMatch.nrid);
					if (idx >= 0) giftTransactions[idx].quantity = remaining.toString();
				}

				// Carry price to the current transaction
				let thisTransaction = giftTransactions.find(g => g.nrid == trans.nrid);
				if (thisTransaction && notesMatch.sharePrice != null) {
					thisTransaction.sharePrice = notesMatch.sharePrice;
					console.log("ADJUSTED Transaction: ", thisTransaction);
				}
				return true;
			}

			console.log("no notes match");
			return false;
		}

		function findNotesMatch(transNotes, priorTrans) {
			console.log("transNotes", transNotes);

			function extractPossibleDate(str) {
				if (!str) return null;
				const dateRegex = /(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)[a-z]*\.?\s*\d{1,2},?\s*\d{2,4}|\b\d{1,2}[\/\-]\d{1,2}[\/\-]\d{2,4}\b/i;
				const match = str.match(dateRegex);
				return match ? match[0] : null;
			}

			const possibleDateString = extractPossibleDate(transNotes || "");
			const transMoment = possibleDateString ? moment(possibleDateString, dateFormats, true) : null;

			for (const t of priorTrans) {
				if (!t || !t.notes || !t.date) continue;

				const notesHit = (transNotes || "").toLowerCase().includes((t.notes || "").toLowerCase());
				if (!notesHit) continue;

				let dateMatch = true; // allow notes-only when no parseable date
				if (transMoment && moment.unix(Number(t.date)).isValid()) {
					const tMoment = moment.unix(Number(t.date));
					dateMatch = tMoment.isSame(transMoment, "day");
				}

				if (dateMatch) {
					console.log("Matched prior transaction:", t);
					return t; // <- returns a single OBJECT
				}
			}
			return false;
		}

		function sameCertificate (transNotes, notes) {
			console.log("transNotes", transNotes);
			console.log("notes", notes);
			if (!CERT_COLUMN) return areSimilar(transNotes, notes);
			// console.log("transNotes", (transNotes.match(/\(([^)]*?(\d+)[^)]*?)\)/) || [])[2])
			// console.log("notes", (notes.match(/\(([^)]*?(\d+)[^)]*?)\)/) || [])[2])
			// return (transNotes.match(/\((\d+)\)/) || [])[1] == (notes.match(/\((\d+)\)/) || [])[1];
			if ((transNotes.match(/\(([^)]*?(\d+)[^)]*?)\)/) || [])[2] == (notes.match(/\(([^)]*?(\d+)[^)]*?)\)/) || [])[2]) {
				console.log("***MATCH***");
				return true;
			} else return false;
		}

		// This method takes a given Send and tries to find a collection of Prior Receives that fits perfectly
		function handlePerfectFit (trans, targetQty, date, isSwapOrSplit) {
			// Look for perfect match
			let priorGrossQty = 0;
			let priorGrossCost = 0;
			// find and remove the prior receive transaction(s) that sum to targetQty
			let priorTrans = giftTransactions.filter(g => Number(g.date) <= date && sameClassAndReceiver(g));
			// Remove active certificates
			priorTrans = priorTrans.filter(p => !p.notes.includes("#"));
			// Remove restricted stock
			if (isEDM) priorTrans = priorTrans.filter(p => !p.notes.startsWith("Restricted"));
			// Sort according to priority
			if (isVERM) priorTrans.sort((a, b) => (Number(a.date) > Number(b.date)) ? 1 : -1);	// oldest to newest
			else {
				priorTrans.sort((a, b) => (Number(a.date) > Number(b.date)) ? -1 : 1);	// newest to oldest
				priorTrans.sort((a, b) => Number(b.quantity) - Number(a.quantity));		// largest to smallest
			}
			console.log("PRIOR Transactions: ", priorTrans);
			// first try with only older transactions
			minDiff = 999;	// reset arbitrarily large starting number used in tranche analysis
			let perfectFit = findSubset(targetQty, priorTrans.filter(g => Number(g.date) < date));
			// now include same-date transactions
			minDiff = 999;	// reset arbitrarily large starting number used in tranche analysis
			if (!perfectFit) perfectFit = findSubset(targetQty, priorTrans);
			if (perfectFit) {
				console.log("PERFECT Fit: ", perfectFit);
				perfectFit.forEach(p => p.tranche = c + "-" + trans.date);
				historicHoldings = historicHoldings.concat(perfectFit);
				let perfectNrids = new Set(perfectFit.map(item => item.nrid));
				giftTransactions = giftTransactions.filter(g => !perfectNrids.has(g.nrid));
				priorGrossQty = perfectFit.reduce((acc, val) => acc + Number(val.quantity), 0);
				priorGrossCost = perfectFit.reduce((acc, val) => acc + (Number(val.quantity) * toNumber(val.sharePrice)), 0);
			} else console.log("no further fit");

			let thisTransaction = giftTransactions.find(g => g.nrid == trans.nrid);
			if (thisTransaction) thisTransaction.sharePrice = (priorGrossCost / (isSwapOrSplit ? Number(thisTransaction.quantity) : priorGrossQty)).toString();
			console.log("ADJUSTED Transaction: ", thisTransaction);
			return perfectFit ? true : false;
		}

		// This subroutine finds a subset of Receives that sum exactly to a target quantity
		function findSubset (targetQty, priorTrans, subset = [], index = 0) {
			// Calculate the current sum of the subset.
			let currentSum = subset.reduce((acc, val) => acc + Number(val.quantity), 0);
			// Check if the current subset sum matches the target quantity.	
			if (currentSum == targetQty) return subset;	// Perfecft match!!!
			// NEW LOGIC: instead of perfect match (i.e. diff == 0 exactly), look for a small enough diff (< 1) is found after many tries (> 99) to do better
			let diff = Math.abs(targetQty - currentSum);
			if (diff < minDiff) {
				minDiff = diff;	// new value used in tranche analysis
				diffCount = 0;	// reset counter when new minDiif is found
				console.log("minDiff = " + minDiff);
			}
			diffCount++;	// increment counter
			if (diff < 1 && diffCount > 99) return subset;	// Bail out if close enough
			// If the sum exceeds the target quantity or we've reached the end of priorTrans, return null.
			if (currentSum > targetQty || index >= priorTrans.length) return null;
			// Include the current transaction and move to the next.
			let includeCurrent = findSubset(targetQty, priorTrans, [...subset, priorTrans[index]], index + 1);
			if (includeCurrent) return includeCurrent;
			// Exclude the current transaction and move to the next.
			return findSubset(targetQty, priorTrans, subset, index + 1);
		}

		// This method scores potential matches, and returns the one with the highest score
		function scoreMatches (transfer, historics) {
			let bestMatch;
			let bestScore = 0;
			if (historics.length) bestMatch = historics[0];
			historics.forEach(h => {
				let score = areSimilar(transfer.notes, h.notes);
				if (transfer.sharePrice == h.sharePrice) score += 3;
				if (transfer.quantity == h.quantity) score += 7;
				if (transfer.notes.toLowerCase().includes(h.notes.toLowerCase())) score += 5;
				if (Number(transfer.sharePrice) < Number(h.sharePrice)) score = 0;
				if (Number(h.quantity) > Number(transfer.quantity)) score += 1;
				if (Number(h.quantity) < Number(transfer.quantity)) score = 0;
				if (Number(transfer.date) < Number(h.date)) score = 0;
				// if (h.notes.includes("#")) score = 0;
				if (score > bestScore) {
					bestScore = score;
					bestMatch = h;
				}
			});
			return bestMatch;
		}

		function scoreDifferences(transfer, historics) {
			let bestMatch;
			let bestScore = -Infinity;	// allow 0 scores
			if (historics.length) bestMatch = historics[0];

			historics.forEach(h => {
				let score = areSimilar(transfer.notes, h.notes);
				if (score > 0.9) score = 0; // handle EO Releases

				// Extract dates from notes
				const transferNoteDate = extractDate(transfer.notes);
				const historicNoteDate = extractDate(h.notes);

				// Strongly prefer a note-date ≈ record .date
				const dateBoost =
					(transferNoteDate && isCloseInTime(transferNoteDate, h.date) ? 1.0 : 0) +
					(historicNoteDate && isCloseInTime(historicNoteDate, transfer.date) ? 0.5 : 0);

				// Small bonus if share prices match (helps pick the Grant @ 318.03)
				const priceBoost = (+transfer.sharePrice && +h.sharePrice &&
					Math.abs(+transfer.sharePrice - +h.sharePrice) < 0.005) ? 0.5 : 0;

				// Down-weight loose text similarity; up-weight structured signals
				const totalScore = (score * 0.3) + dateBoost + priceBoost;

				if (totalScore > bestScore) {
					bestScore = totalScore;
					bestMatch = h;
				}
			});

			return bestMatch;

			// Extract timestamp (ms) from note string if any recognizable date found
			function extractDate(text) {
				const match = text.match(/(\d{1,4}[\/\-]\d{1,2}[\/\-]\d{1,4}|\w{3} \d{1,2}, \d{4})/);
				if (match) {
					const m = moment(match[0], dateFormats, true);
					if (m.isValid()) return m.valueOf(); // ms since epoch
				}
				return null;
			}

			// True if two dates are within ±5 days (input: ms, seconds)
			function isCloseInTime(msFromNote, dateStampSeconds) {
				const dateFromItem = Number(dateStampSeconds) * 1000;
				const delta = Math.abs(msFromNote - dateFromItem);
				return delta <= 5 * 24 * 60 * 60 * 1000; // ±5 days in ms
			}
		}

		// Character overlap similarity (basic fuzzy match)
		function areSimilar(a, b) {
			const setA = new Set(a.toLowerCase());
			const setB = new Set(b.toLowerCase());
			const overlap = [...setA].filter(c => setB.has(c)).length;
			const avgLen = (setA.size + setB.size) / 2;
			return overlap / avgLen;
		}

		function notRestricted (trans) {
			const note = trans.notes?.toLowerCase() || "";
			return !(note.includes("restricted stock grant") || note.includes("stock award"));
		}

		function sameClassAndSender (trans) { return trans.shareClass == c && trans.sender == giftUserId; }

		function sameClassAndReceiver (trans) { return trans.shareClass == c && trans.receiver == giftUserId; }
	});

	let filterViewGT = document.getElementById('filterViewGiftTrans');

	stringOptions = m0;
	if (document.getElementById('showDecimals').checked) stringOptions = m2;

	if (true) {	//includedClasses.length <= 1) {
		document.getElementById('filterWrapViewGiftTrans').style.display = 'none';
	} else {
		document.getElementById('filterWrapViewGiftTrans').style.display = 'block';
		let labelViewGT = document.getElementById('labelViewGiftTrans');
		if (labelViewGT) labelViewGT.innerHTML = clientData.use_real_estate_language ? "Property" : UFL ? "Fund" : "Share&nbsp;Class";

		if (isJMS || isACC) selectedClass = classes[0];
		else includedClasses.unshift("ALL");
		
		filterViewGT.innerHTML = `
			<option value="" disabled selected>Select</option>
			${includedClasses.map((className, index) =>
				`
					<option ${index == 0 ? 'selected' : ''} value="${className}">${className}</option>
				`
			).join('')}
			<label>Fund</label>

		`
	}

	// let viewOptions = ["Show&nbsp;Zeros","Show&nbsp;All","Hide&nbsp;All"];
	// document.getElementById('selectView').innerHTML = `
	// 	<select id="selectViewInput" name="view">
	// 		<option value="" selected>Show&nbsp;Positves</option>
	// 		${viewOptions.map((view, index) =>
	// 			`
	// 				<option value="${view}">${view}</option>
	// 			`
	// 		).join('')}
	// 	</select>
	// `

	let treasuryId;
	let giftSources;
	let lastCertNum;
	let nextCertNum;
	let recipientId;
	let recipientName;
	let currentTranche;

	let holders = [];
	let gifts = [" "];
	let theseGifts = {};
	const NEW_CODE = true;
	theseGifts[" "] = ["","",,];

	// Remove giftTransactions with quantity == 0;  <-- NO !!
	// giftTransactions = giftTransactions.filter(g => g.quantity != "0");

	if (giftTransactions.length > 0 || NEW_CODE) showFilteredGiftTrans();

	function showFilteredGiftTrans () {
		console.log("origTransactions: ", origTransactions);
		console.log("giftTransactions: ", giftTransactions);
		console.log("historicHoldings: ", historicHoldings);
		console.log("priorTransfers: ", priorTransfers);
		// let filteredTransactions = isMAZ ? giftTransactions : origTransactions;
		let filteredTransactions = NEW_CODE ? giftTransactions.concat(historicHoldings).concat(priorTransfers) : origTransactions;
		filteredTransactions = filteredTransactions.filter(t => !(clientData.equity[t.shareClass] && clientData.equity[t.shareClass].hasOwnProperty('interestRate')));
		if (selectedClass && selectedClass != "ALL") {
			filteredTransactions = filteredTransactions.filter(function(item) {
				if (item.shareClass) return item.shareClass == selectedClass;
				else return true;
			});
		}
		renderUserGiftTransModal(filteredTransactions);
	}

	function renderUserGiftTransModal (filteredGiftTransactions) {

		// By date then descending cost basis
		function sortByClassThenBasisThenDateThenQty (transArray) {
			transArray.sort((a, b) => {
				if (isVERM) {
					// First, sort by 'class' (assuming it's a string)
					if (a.shareClass < b.shareClass) return -1;
					if (a.shareClass > b.shareClass) return 1;
					// Next, sort by 'date' as numbers
					let dateA = Number(a.date);
					let dateB = Number(b.date);
					if (dateA < dateB) return -1;
					if (dateA > dateB) return 1;
				}
				else if (!isBB) {
					// First, sort by 'date' as numbers
					let dateA = Number(a.date);
					let dateB = Number(b.date);
					if (dateA < dateB) return 1;
					if (dateA > dateB) return -1;
					// Next, sort by 'class' (assuming it's a string)
					if (a.shareClass < b.shareClass) return -1;
					if (a.shareClass > b.shareClass) return 1;
				}
				// Then, sort by 'sharePrice' as numbers
				let sharePriceA = isNaN(a.sharePrice) ? 0 : Number(a.sharePrice);
				let sharePriceB = isNaN(b.sharePrice) ? 0 : Number(b.sharePrice);
				if (sharePriceA < sharePriceB) return 1;
				if (sharePriceA > sharePriceB) return -1;
				if (isBB) {
					// First, sort by 'class' (assuming it's a string)
					if (a.shareClass < b.shareClass) return -1;
					if (a.shareClass > b.shareClass) return 1;
					// Next, sort by 'date' as numbers
					let dateA = Number(a.date);
					let dateB = Number(b.date);
					if (dateA < dateB) return -1;
					if (dateA > dateB) return 1;
				}
				// Finally, sort by 'quantity' as numbers
				let quantityA = Number(a.quantity);
				let quantityB = Number(b.quantity);
				if (quantityA < quantityB) return -1;
				if (quantityA > quantityB) return 1;
				// If all the criteria are equal, maintain original order
				return 0;
			});
			return transArray;
		}

		// Put giftTransactions with quantityu == "0" at the end
		let nonZero = filteredGiftTransactions.filter(t => Number(t.quantity) != 0);
		let zeroQty = filteredGiftTransactions.filter(t => Number(t.quantity) == 0).sort((a, b) => Number(b.date) - Number(a.date));;

		filteredGiftTransactions = sortByClassThenBasisThenDateThenQty(nonZero).concat(zeroQty);


		// Compile list of reference prices from Valuations
		let referenceVals = [];
		classes.forEach(function(c) {
			let clientEquity = clientData.equity[c];
			if (clientEquity) {
				if (clientEquity.valuations) {
					clientEquity.valuations.forEach(function(v) {
						let ref = {
							class: c,
							date: v.date,
							price: v.sharePrice,
							ref: v.referencePrice
						}
						referenceVals.push(ref);
					});
				}
				if (clientEquity.transactions)
					CERT_COLUMN ||= clientEquity.transactions.some(t => t.notes.includes('#'));
			} 
		});

		// insert reference price if available
		let ttlTrans = 0;
		Object.keys(filteredGiftTransactions).forEach(function (trans , i) {
			let t = filteredGiftTransactions[trans];
			let refPrice = referenceVals.find(v => v.class == t.shareClass && Number(v.price) == Number(t.sharePrice) && v.date <= t.date);
			if (refPrice) filteredGiftTransactions[i].referencePrice = refPrice.ref;
			ttlTrans += filteredGiftTransactions[i].receiver == shareholder ? Number(filteredGiftTransactions[i].quantity) : 0;
		});

		console.log(filteredGiftTransactions.filter(t => !t.receiver));
		// historicHoldings = filteredGiftTransactions.filter(t => t.receiver.toLowerCase() == shareholder);
		// priorTransfers = filteredGiftTransactions.filter(t => t.sender.toLowerCase() == shareholder);

		// historicHoldings = filteredGiftTransactions.filter(t => historicHoldings.some(h => h.nrid == t.nrid));
		// priorTransfers = filteredGiftTransactions.filter(t => priorTransfers.some(p => p.nrid == t.nrid));

		// Put giftTransactions with quantityu == "0" at the end
		nonZero = giftTransactions.filter(t => Number(t.quantity) != 0);
		zeroQty = giftTransactions.filter(t => Number(t.quantity) == 0).sort((a, b) => Number(b.date) - Number(a.date));;

		giftTransactions = sortByClassThenBasisThenDateThenQty(nonZero).concat(zeroQty);
		historicHoldings = sortByClassThenBasisThenDateThenQty(historicHoldings);
		priorTransfers = sortByClassThenBasisThenDateThenQty(priorTransfers);
		historicHoldings.sort((a, b) => {
			let [classA, dateA] = a.tranche.split("-");
			let [classB, dateB] = b.tranche.split("-");
			dateA = Number(dateA);
			dateB = Number(dateB);
			if (dateA < dateB) return 1;
			if (dateA > dateB) return -1;
			if (classA < classB) return -1;
			if (classA > classB) return 1;
			return 0;
		});
		historicHoldings.sort((a, b) => {
			a.tranche > b.tranche ? -1 : 1
		});
		console.log("POST giftTransactions: ", giftTransactions);
		console.log("POST historicHoldings: ", historicHoldings);
		console.log("POST priorTransfers: ", priorTransfers);

		let letterCount = 0;
		giftTransactions.forEach(function (h, i) {
			let trancheLetter = numberToLetters(letterCount);
			if (!h.tranche || h.tranche.length > 3) {
				h.tranche = trancheLetter;
				letterCount++;
			}
			if (!h.before) h.before = h.quantity;
		});
		historicHoldings.forEach(function (h, i) {
			let trancheLetter = numberToLetters(letterCount);
			if (!h.tranche) {
				h.tranche = trancheLetter;
				letterCount++;
			} else if (h.tranche.length > 3) {
				let timeStamp = h.tranche;
				historicHoldings.forEach(k => {
					if (k.tranche == timeStamp) {
						k.tranche = trancheLetter;
					}
				});
				priorTransfers.forEach(p => { if (p.tranche == timeStamp) p.tranche = trancheLetter; });
				letterCount++;
			}
			if (!h.before) h.before = h.quantity;
		});

		// Amy does not find this headline insert  helpful
		// if (priorTransfers.length) {
		// 	balanceHeadline.innerHTML = 'Shares Owned Now:&emsp;<span class="text-primary">' + ttlTrans.toLocaleString() +
		// 		`</span>&nbsp;Cumulative&emsp;<span id="balanceBeforElem" class="text-primary">` + balanceBefore.toLocaleString() +
		// 		`</span>&nbsp;Before&emsp;<span id="balanceAfterElem" class="text-primary${balanceAfter.after < 0 ? ' red-text font-bold' : ''}">` +
		// 		balanceAfter.toLocaleString() + `</span>&nbsp;After`;
		// 	balanceHeadline.classList.remove('m5');
		// 	balanceHeadline.classList.add('m6');
		// 	giftHeadline.classList.remove('m5');
		// 	giftHeadline.classList.add('m4');
		// }

		/* TRANCHE MATCHING RULES / SCORING
		   - Same cost basis (3 pts)
		   - Same number of shares (6 pts, split??)
		   - Same notes (3 pts)
		   - Later or equal date (required)
		   - Disqualifying: lower basis, earlier date
		*/

		// OLD CODE does nothing (next 80 lines)
		let scoreArray = [15,12,10,8,7,5,3];
		scoreArray.forEach(s => scoreMatches_OLD(priorTransfers, historicHoldings, s));

		// get perfect matches first
		// reduce arrays and look for next best
		let priorOpens = priorTransfers.filter(p => p.tranche == null);
		let priorMatches = priorTransfers.filter(p => p.tranche != null);
		priorOpens.forEach(function(m, i) {
			let match = historicHoldings.findIndex(h => h.tranche == m.tranche);
			if (match > -1) {
				let hQty = Number(historicHoldings[match].quantity);
				let mQty = Number(m.quantity);
				if (hQty >= mQty) {
					historicHoldings[match].quantity = (hQty - mQty).toString();
					priorOpens.quantity = "0";
				} else {
					historicHoldings[match].quantity = "0";
					priorOpens.quantity = (mQty - hQty).toString();
				}
			}
		});

		// let historicPrices = [];
		// historicHoldings.forEach(h => historicPrices.push(Number(h.sharePrice)));
		// historicPrices = historicPrices.sort((a, b) => a - b);

		// If there remain unmatched prior transfers, start assigning them to tranches with the highest cost basis
		priorTransfers.forEach(function(p, i) {
			if (!p.tranche) {
				let priorQty = Number(p.quantity);
				let safety = 0;
				while (priorQty > 0 && !priorTransfers[i].tranche && safety < 100) {
					safety++;
					console.log("safety = " + safety)
					historicHoldings.forEach(function(h, j) {
						if (historicHoldings[j].quantity != "0" && !priorTransfers[i].tranche) {
							if (priorTransfers[i].tranche) priorTransfers[i].tranche += ',' + historicHoldings[j].tranche;
							else priorTransfers[i].tranche = historicHoldings[j].tranche;
							let hQty = Number(historicHoldings[j].quantity);
							let pQty = Number(p.quantity);
							if (hQty >= pQty) {
								historicHoldings[j].quantity = (hQty - pQty).toString();
								priorQty = 0;
							} else {
								historicHoldings[j].quantity = "0";
								priorQty = pQty - hQty;
							}
						}
					});
				}
			}
		});

		function scoreMatches_OLD (priors, historics, threshold) {
			Object.keys(priors).forEach(function (p, i) {
				// console.log(i + p + " priorTransfers[p].tranche = " + priorTransfers[p].tranche)
				if (priorTransfers[p].tranche) return;
				// console.log(i + " pQty = " + priors[p].quantity)
				Object.keys(historics).forEach(function (h, j) {
					if (priorTransfers[p].tranche) return;
					let score = 0;
					if (historics[h].quantity == "0") return;
					if (priors[p].sharePrice == historics[h].sharePrice) score += 3;
					if (priors[p].quantity == historics[h].quantity) score += 7;
					if (priors[p].notes.toLowerCase().includes(historics[h].notes.toLowerCase())) score += 5;
					if (Number(priors[p].sharePrice) < Number(historics[h].sharePrice)) score = 0;
					if (Number(priors[p].date) < Number(historics[h].date)) score = 0;
					if (score == threshold) {
						let thisTranche = historics[h].tranche;
						priorTransfers[p].tranche = thisTranche;
						let hQty = Number(historics[h].quantity);
						let pQty = Number(priors[p].quantity);
						if (hQty >= pQty) {
							historics[h].quantity = (hQty - pQty).toString();
							// priors[p].quantity = "0";
						} else {
							historics[h].quantity = "0";
							// priors[p].quantity = (pQty - hQty).toString();
						}
						// console.log(i + " thisTranche = " + thisTranche)
						return;
					}
				});
			});
		}

		let ttlPrior = 0;
		let ttlHist = 0;
		priorTransfers.forEach(p => ttlPrior += Number(p.quantity));
		historicHoldings.forEach(h => ttlHist += Number(h.quantity));

		priorTransfers = priorTransfers.sort((a, b) => a.tranche < b.tranche ? -1 : 1);
		stringOptions = isTBC ? m6 : m5;
		if (CERT_COLUMN) {
			// insert certificate number if available
			filteredGiftTransactions.forEach(function(f, index) {
				let certNumber = "";
				if (f.notes) {
					certNumber = getCertNumber(f.notes);
				}
				if (certNumber && certNumber[2]) {
					filteredGiftTransactions[index].certNumber = certNumber[2];
					let certSort = certNumber[2].split('-')[1];
					filteredGiftTransactions[index].certSort = Number((certSort ? certSort : certNumber[2]).replace(/[^\d.]/g, ''));
				} else {
					filteredGiftTransactions[index].certNumber = "";
					filteredGiftTransactions[index].certSort = 0;
				}
			});
			historicHoldings.sort((a, b) => a.certSort < b.certSort ? -1 : 1);
		}

		//restore original sharePrice
		giftTransactions.forEach(t => {
			let origTrans = origTransactions.find(o => o.nrid == t.nrid);
			if (origTrans) t.sharePrice = origTrans.sharePrice;
		});

		let userTransactionsMarkup = `
			${filteredGiftTransactions.length || true ? `
				<div class="table-wrap card p-1 mt-4 mb-2">
					<div class="sm-hz-scroll-no-margin">

						${!giftTransactions.length ? 
						`
							<div class="bg-grey-lightest rounded border-grey grey-text center-align p-1 mt-4">
								No available holdings to send. To create a new holding, click <a id="newHoldingButton" class="link-accent">here</a>.<br><span class="text-sm">Gift Transfers require at least one "open" (unmatched) Transaction with ${giftUserData.user_name} as the receiver.</span>
							</div>
						` : `
						<table id="historicalsSortTable" class="highlight table-content">
							<thead>
								<tr style="height: 30px;">
									<th class="text-sm center-align p-0" style="width:8%" data-sort-default>Tranche</th>
									${CLASS_COLUMN ? `<th class="text-sm center-align p-0" style="width:8%">Class</th>` : ``}
									${CERT_COLUMN ? `<th class="text-sm center-align p-0" style="width:8%">Cert #</th>` : ``}
									<th class="text-sm center-align p-0" style="width:15%">Date</th>
									<th class="text-sm p-0">Description</th>
									<!-- <th>Sender</th> -->
									<!-- <th>Receiver</th> -->
									<th class="text-sm center-align p-0" style="width:12%">Initial</th>
									<th class="text-sm center-align p-0" style="width:12%">Remaining</th>
									<th class="${USE_TAX_BASIS ? 'hidden ' : ''}text-sm center-align p-0" style="width:10%">Cost&nbsp;Basis</th>
									<th class="hidden">Exact Basis</th>
									<th class="hidden">Reference Basis</th>
									<th class="hidden">Qty * Exact Basis</th>
									<th class="hidden">Qty * Ref. Basis</th>
									${USE_TAX_BASIS ? `<th class="center-align">Tax Basis</th>` : ``}
								</tr>
							</thead>
							<tbody>
							${giftTransactions.map((t, i) =>
								`
								<tr id="historicsTable${i}" ${t.quantity == "0" ? 'class="hidden"' : ''} style="height: 10px;">
									<td class="p-0" data-sort='${lettersToNumbers(t.tranche)}'>
										<div class="shareholder-row" style="position: relative;">
											<p id="cbElem-${t.tranche}" class="${fromUser ? '' : 'selectShareholder'} ml-6 mt-0 mb-0" style="overflow: hidden; text-align: center;">
												${fromUser ? `` : `
													<label>
														<input class="selectTrancheInput" type="checkbox" data-tranche=${t.tranche} data-class=${t.shareClass} />
														<span></span>
													</label>
												`}
											</p>
											<div id="imgElem-${t.tranche}" class="text-sm font-bold ${fromUser ? '' : 'shareholder-img'} center-align ml-6">${t.tranche}</div>
										</div>
									</td>
									${CLASS_COLUMN ? `
									<td class="text-xs center-align p-0" style="width: 80px; max-width: 80px;">
										${t.shareClass}
									</td>` : ``}
									${CERT_COLUMN ? `
									<td class="text-xs center-align p-0" style="width: 80px; max-width: 80px;" data-sort='${t.certSort}'>
										${t.certNumber}
									</td>` : ``}
									<td class="text-xs center-align p-0" data-sort='${t.date}'>
										${moment.unix(t.date).format("MMM D, YYYY")}
									</td>
									<td class="text-xs p-0">
										${t.notes}
									</td>
									<!-- <td class="text-xs p-0">
										${t.senderName ? t.senderName : "Issuer"}
									</td> -->
									<!-- <td class="text-xs p-0">
										${t.receiverName ? t.receiverName : "Issuer"}
									</td> -->
									<td class="text-xs center-align p-0">
										${Number(t.before).toLocaleString('en-US', m5)}
									</td>
									<td id="quantity${t.tranche}" class="text-xs center-align p-0">
										${Number(t.quantity.replace(/[^.\d]/g, '')).toLocaleString('en-US', m5)}
									</td>
									<td class="${USE_TAX_BASIS ? 'hidden ' : ''}text-xs center-align p-0">
										${t.sharePrice && !isNaN(t.sharePrice) ? (Number(t.sharePrice.replace(/[^.\d]/g, ''))).toLocaleString('en-US', usp) : "n.a."}
									</td>
									<td class="hidden">
										${t.sharePrice && !isNaN(t.sharePrice) ? (Number(t.sharePrice.replace(/[^.\d]/g, ''))).toLocaleString('en-US', usp) : "n.a."}
									</td>
									<td class="hidden">
										${t.referencePrice && !isNaN(t.referencePrice) ? (Number(t.referencePrice.replace(/[^.\d]/g, ''))).toLocaleString('en-US', usp) : ""}
									</td>
									<td class="hidden">
										${t.quantity && t.sharePrice && !isNaN(t.sharePrice) ? (Number(t.quantity.replace(/[^.\d]/g, '')) * Number(t.sharePrice.replace(/[^.\d]/g, ''))).toLocaleString('en-US', usp) : ""}
									</td>
									<td class="hidden">
										${t.quantity && t.referencePrice && !isNaN(t.referencePrice) ? (Number(t.quantity.replace(/[^.\d]/g, '')) * Number(t.referencePrice.replace(/[^.\d]/g, ''))).toLocaleString('en-US', usp) : ""}
									</td>
									${USE_TAX_BASIS ? `
										<td class="text-xs center-align p-0">
											${!t.strikePrice || isNaN(t.strikePrice) ? "n.a." : Number(t.strikePrice.replace(/[^.\d]/g, '')).toLocaleString('en-US', usp)}
										</td>
									` : ``}
								</tr>
								`).join('')}
								<tfoot id="historicalsFooter">
									<tr style="height: 36px;"">
										<td id="consolidate" class="text-xs py-0 px-4" style="max-width: 50px; white-space: nowrap; overflow: visible; position: relative; z-index: 2;"></td>
										${CLASS_COLUMN ? `<td class="p-0"></td>` : ``}
										${CERT_COLUMN ? `<td class="p-0"></td>` : ``}
										<td class="p-0"></td>
										<td class="p-0"></td>
										<td id="totalBefore" class="text-xs font-bold center-align p-0"></td>
										<td id="totalAfter" class="text-xs font-bold center-align p-0"></td>
										<td id="avgCostBasis" class="text-xs font-bold center-align p-0"></td>										
										<!-- <td class="text-xs font-bold center-align p-0">${ttlTrans.toLocaleString('en-US', stringOptions)}</td> -->
										<!-- <td class="text-xs font-bold center-align p-0">${ttlHist.toLocaleString('en-US', stringOptions)}</td> -->
									</tr>
								</tfoot>
							</tbody>
						</table>
					`}

					<!-- OLD TABLE (not displyed) -->
					${priorTransfers.length ? `
						<div id="showHidePriorsDiv" class="mb-0 mt-3">
							<span id="showHidePriors" class="text-xs ml-6 p-0 link-accent">
								Show Prior Tranches
							</span>
						</div>

						<table id="priorsSortTable" class="highlight table-content hidden">
							<thead>
								<tr class="">
									<th class="text-xs center-align p-0" style="width:8%" data-sort-default>Tranche</th>
									${CLASS_COLUMN ? `<th class="center-align" style="width:12%">Class</th>` : ``}
									${CERT_COLUMN ? `<th class="center-align" style="width:12%">Cert #</th>` : ``}
									<th class="text-xs center-align p-0" style="width:15%">Date</th>
									<th class="text-xs p-0" style="width:43%">Description</th>
									<!-- <th>Sender</th> -->
									<!-- <th>Receiver</th> -->
									<th class="text-xs center-align p-0" style="width:12%">Initial</th>
									<th class="text-xs center-align p-0" style="width:12%">Remaining</th>
									<th class="text-xs center-align p-0" style="width:10%">Cost&nbsp;Basis</th>
									<th class="hidden">Exact Basis</th>
									<th class="hidden">Reference Basis</th>
									<th class="hidden">Qty * Exact Basis</th>
									<th class="hidden">Qty * Ref. Basis</th>
								</tr>
							</thead>
							<tbody>
							${priorTransfers.map((t, i) =>
								`
								<tr id="priorsTable${i}">
									<td class="text-xs center-align p-0" data-sort='${lettersToNumbers(t.tranche)}'>
										${t.tranche}
									</td>
									${CLASS_COLUMN ? `
									<td class="text-xs center-align" style="width: 80px; max-width: 80px;">
										${t.shareClass}
									</td>` : ``}
									${CERT_COLUMN ? `
									<td class="text-xs center-align" style="width: 80px; max-width: 80px;" data-sort='${t.certSort}'>
										${t.certNumber}
									</td>` : ``}
									<td class="text-xxs center-align p-0" data-sort='${t.date}'>
										${moment.unix(t.date).format("MMM D, YYYY")}
									</td>
									<td class="text-xxs p-0">
										${t.notes}
									</td>
									<!-- <td class="text-xxs p-0">
										${t.senderName ? t.senderName : "Issuer"}
									</td> -->
									<!-- <td class="text-xxs p-0">
										${t.receiverName ? t.receiverName : "Issuer"}
									</td> -->
									<td class="text-xxs center-align p-0">
										0
									</td>
									<td id="quantity${t.tranche}" class="text-xxs center-align p-0">
										${Number(t.quantity.replace(/[^.\d]/g, '')).toLocaleString('en-US', m5)}
									</td>
									<td class="text-xxs center-align p-0">
										${t.sharePrice && !isNaN(t.sharePrice) ? (Number(t.sharePrice.replace(/[^.\d]/g, ''))).toLocaleString('en-US', usp) : "n.a."}
									</td>
									<td class="text-xs center-align p-0 hidden">
										${t.sharePrice && !isNaN(t.sharePrice) ? (Number(t.sharePrice.replace(/[^.\d]/g, ''))).toLocaleString('en-US', usp) : "n.a."}
									</td>
									<td class="text-xs center-align p-0 hidden">
										${t.referencePrice && !isNaN(t.referencePrice) ? (Number(t.referencePrice.replace(/[^.\d]/g, ''))).toLocaleString('en-US', usp) : ""}
									</td>
									<td class="text-xs center-align p-0 hidden">
										${t.quantity && t.sharePrice && !isNaN(t.sharePrice) ? (Number(t.quantity.replace(/[^.\d]/g, '')) * Number(t.sharePrice.replace(/[^.\d]/g, ''))).toLocaleString('en-US', usp) : ""}
									</td>
									<td class="text-xs center-align p-0 hidden">
										${t.quantity && t.referencePrice && !isNaN(t.referencePrice) ? (Number(t.quantity.replace(/[^.\d]/g, '')) * Number(t.referencePrice.replace(/[^.\d]/g, ''))).toLocaleString('en-US', usp) : ""}
									</td>
								</tr>
								`).join('')}
								<tfoot id="priorsFooter">
									<tr>
										<td class="p-0"></td>
										${CLASS_COLUMN ? `<td class="p-0"></td>` : ``}
										${CERT_COLUMN ? `<td class="p-0"></td>` : ``}
										<td class="p-0"></td>
										<td class="p-0"></td>
										<td class="text-xs font-bold center-align p-0">0</td>
										<td class="text-xs font-bold center-align p-0">${ttlPrior.toLocaleString('en-US', stringOptions)}</td>
										<td class="p-0"></td>
									</tr>
								</tfoot>
							</tbody>
						</table>
						` : ``}
					</div>

					<table id="trancheTable" class="highlight table-content hidden">
						<thead>
							<tr>
								<th class="text-xs center-align p-05" style="width:4%" data-sort-default>Tranche</th>
								<th class="text-xs center-align p-05" style="width:6%">Class</th>
								<th class="text-xs p-05">Historic Holdings (source)</th>
								<th class="text-xs p-05">Prior Transfers (destination)</th>
							</tr>
						</thead>
						<tbody id="tableBody">
							<!-- Table rows will be added here -->
						</tbody>
					</table>

				</div>
			` : ``
			}
		`;

		let table, sort;
		userGiftTransferTable.innerHTML = userTransactionsMarkup;
		table = document.getElementById('historicalsSortTable');
		if (table) sort = new Tablesort(table, { ascending: true });

		let tranches = new Set([...priorTransfers, ...historicHoldings].map(item => item.tranche));
		let sortedTranches = Array.from(tranches).sort((a,b) => lettersToNumbers(a) - lettersToNumbers(b));

		sortedTranches.forEach(tranche => {
			let transfers = priorTransfers.filter(item => item.tranche == tranche);
			let holdings = historicHoldings.filter(item => item.tranche == tranche);
			if (transfers.length) {
				let sumTransfers = transfers.reduce((a, b) => a + Number(b.quantity), 0);
				let sumHoldings = holdings.reduce((a, b) => a + Number(b.quantity), 0);
				// if (sumTransfers != sumHoldings) alert ("Tranche " + tranche + " sum mismatch (" + sumHoldings + " <> " + sumTransfers + ").");
				if (Math.abs(sumTransfers - sumHoldings) >= 1) {
					let trancheError = "Tranche " + tranche + " sum mismatch (" + sumHoldings + " != " + sumTransfers + ")."
					let trancheLog = localStorage.getItem('TrancheLog');
					trancheLog += "\n" + trancheError;
					localStorage.setItem('TrancheLog', trancheLog);
					if (!getCookie('userIndex') && authedUser == "cmcconnell@nthround.com") showToast("warning-toast", trancheError, 10000);
				}
				holdings.sort((a, b) => Number(a.quantity) - Number(b.quantity));
				transfers.sort((a, b) => Number(a.quantity) - Number(b.quantity));
				addTableRow(tranche, holdings, transfers, sumTransfers);				
			}
		});

		function addTableRow(tranche, holdings, transfers, sumTransfers) {
			let tableBody = document.getElementById('tableBody');
			let row = document.createElement('tr');

			let trancheCell = document.createElement('td');
			let trancheDate = transfers[0] ? moment.unix(transfers[0].date) : moment();
			trancheCell.innerHTML = tranche + '<p class="text-xxs font-md mt-1 mb-0">' + trancheDate.format("MMM D") + '<br>' + trancheDate.format("YYYY") + '</p>';
			trancheCell.classList.add('text-xs','font-bold','center-align','p-0');
			trancheCell.setAttribute("data-sort", lettersToNumbers(tranche));
			row.appendChild(trancheCell);

			let classCell = document.createElement('td');
			let trancheClass = transfers[0] ? transfers[0].shareClass : "?";
			classCell.innerHTML = trancheClass + '<p class="text-xxs mt-1 mb-0">' + sumTransfers.toLocaleString() + '<br>shares</p>';
			classCell.classList.add('text-xs','center-align','p-0');
			row.appendChild(classCell);

			let holdingsCell = document.createElement('td');
			holdingsCell.innerHTML = holdings.map(h => h.notes + ' - ' + Number(h.quantity).toLocaleString() + ' shares from ' + h.senderName.replace("Issuer", capitalize(client)) + '<span class="text-secondary">&ensp;' + (h.sharePrice && !isNaN(h.sharePrice) ? (Number(h.sharePrice.replace(/[^.\d]/g, ''))).toLocaleString('en-US', usp) : "") + '</span>').join('<br>');
			if (isVERM) holdingsCell.innerHTML = holdingsCell.innerHTML.replace(/from Vermeer/g, 'reissued');
			holdingsCell.classList.add('text-xs');
			row.appendChild(holdingsCell);

			let transfersCell = document.createElement('td');
			transfersCell.innerHTML = transfers.map(t => t.notes + ' - ' + Number(t.quantity).toLocaleString() + ' shares to ' + t.receiverName.replace("Issuer", capitalize(client)) + '<span class="text-secondary">&ensp;' + (t.sharePrice && !isNaN(t.sharePrice) ? (Number(t.sharePrice.replace(/[^.\d]/g, ''))).toLocaleString('en-US', usp) : "") + '</span>').join('<br>');
			if (isVERM) transfersCell.innerHTML = transfersCell.innerHTML.replace(/to Vermeer/g, 'cancelled');
			transfersCell.classList.add('text-xs');
			row.appendChild(transfersCell);

			tableBody.appendChild(row);
		}

		let tableP, sortP;
		tableP = document.getElementById('trancheTable');
		if (tableP) sortP = new Tablesort(tableP, { ascending: true });

		if (addedGiftTransferListenersAlready) showTotals();
	}

	const debtEquityTabs = document.getElementById('debtEquityTabs');
	const priorsSortTable = document.getElementById('trancheTable');
	const showHidePriors = document.getElementById('showHidePriors');
	const selectRecipient = document.getElementById('selectRecipient');
	const addRecipientBtn = document.getElementById('addRecipientBtn');
	const newHoldingButton = document.getElementById('newHoldingButton');
	const showHidePriorsDiv = document.getElementById('showHidePriorsDiv');
	const selectRecipientDiv = document.getElementById('selectRecipientDiv');
	const previewGiftTransfer = document.getElementById('previewGiftTransfer');
	const statementWaitHeader = document.getElementById('statementWaitHeader');
	const totalCurrentValueDiv = document.getElementById('totalCurrentValueDiv');
	const historicalsSortTable = document.getElementById('historicalsSortTable');

	if (showHidePriors) showHidePriors.addEventListener('click', function(e) {
		document.getElementById('viewGiftTransferModal').style.overflowY = "auto";
		if (priorsSortTable.classList.contains('hidden')) {
			priorsSortTable.classList.remove('hidden');
			showHidePriorsDiv.classList.remove('mb-0');
			showHidePriorsDiv.classList.add('mb-2');
			this.innerText = "Hide Prior Tranches";
		} else {
			showHidePriorsDiv.classList.remove('mb-2');
			showHidePriorsDiv.classList.add('mb-0');
			priorsSortTable.classList.add('hidden');
			this.innerText = "Show Prior Tranches";
		}
	});

	if (!addedGiftTransferListenersAlready) {
		addedGiftTransferListenersAlready = true;
		let showHideZeros = document.getElementById('showHideZeros');
		if (showHideZeros) {
			showHideZeros.addEventListener('click', function(e) {
				historicalsSortTable?.classList.toggle('hidden', toggle === "Hide All");
				if (toggle !== "Hide All") {
					let len = giftTransactions.length;	//historicHoldings.length;
					for (let i = 0; i < len; i++) {
						let thisRow = document.getElementById('historicsTable' + i);
						let isZero = thisRow.cells[4].innerText.trim() === "0";
						if (toggle === "Show All" || (toggle === "Show Positves" && !isZero) || (toggle === "Show Zeros" && isZero)) thisRow.classList.remove('hidden');
						else thisRow.classList.add('hidden');
					}
				}
				if (toggle === "Show All" || toggle === "Show Positves") showTotals();
				switch (toggle) {
					// case "Open Modal": toggle = "Hide All"; break;
					case "Show Positves": toggle = "Hide All"; break;
					case "Show Zeros": toggle = "Show Positves"; break;
					case "Show All": toggle = "Show Zeros"; break;
					case "Hide All": toggle = "Show All"; break;
				}
				this.innerText = toggle;
			});
		}
		addRecipientBtn.addEventListener('click', async function (e) { // 🔹 Add `async`
			e.preventDefault();
			// document.getElementById('viewGiftTransferModal').style.overflowY = "visible";
			if (selectRecipientDiv.classList.contains('hidden')) {
				selectRecipient.selectedIndex = 0;
				selectRecipient.dispatchEvent(new Event('change'));
				selectRecipientDiv.classList.remove('hidden');
				totalCurrentValueDiv.classList.add('hidden');
			} else {
				selectRecipientDiv.classList.add('hidden');
				totalCurrentValueDiv.classList.remove('hidden');
			}
			await getNextCertNumber();
		});
		selectRecipient.addEventListener('change', function (e) {
			if (!this.value) return;
			// document.getElementById('viewGiftTransferModal').style.overflowY = "auto";
			let id, recip;
			let name = DOMPurify.sanitize(this.value.trim());
			// let name = this.value.includes('|') ? this.value.split('|')[1].trim() : this.value.trim();
			if (name == "Issuer") {
				id = "Issuer";
				recip = { userid: "issuer", user_name: `${clientData.company_name} (Issuer)`, clients: { [client]: {shares: {}} } };
			} else {
				// see if the name has the email already, or if it's BB-style name
				let id = name.split("|")[1].trim();
				if (!validator.isEmail(id)) id = capTableData.find(u => u.user_name == name).userid;
				if (!id || id == giftUserId) return;
				recip = members ? members.find(u => u.userid == id) : capTableData ? capTableData.find(u => u.userid == id) : null;
			}
			if (recip && !giftRecipients.find(r => r.userid == id)) giftRecipients.push(recip);
			selectRecipientDiv.classList.add('hidden');
			totalCurrentValueDiv.classList.remove('hidden');
			renderGiftRecipients();
			// viewGiftTransferModal.scrollTo({ top: 0, behavior: 'smooth' });
			renderNewGiftListeners();
			buildSelectRecipientOptions();
			document.getElementById(recip.userid + 'AddGift').dispatchEvent(new Event('click'));
		});
		document.getElementById('removeRecipientBtn').addEventListener('click', function (e) {
			let giftsToRemove = allGifts.filter(g => g.receiver == removeGiftId);
			giftsToRemove.forEach(g => {
				adjustBalances(-Number(g.quantity.replace(/[^-.\d]/g, '')), g.receiver, g.tranche);
				if (g.notes.includes(lastCertNum[g.shareClass])) nextCertNum[g.shareClass] = lastCertNum[g.shareClass];
			});
			giftRecipients = giftRecipients.filter(r => r.userid != removeGiftId);
			allGifts = allGifts.filter(g => g.receiver != removeGiftId);
			M.Modal.getInstance(document.getElementById('confirmRecipientRemove')).close();
			let recipientDiv = document.getElementById(removeGiftId + '|Div');
			recipientDiv.outerHTML = "";
			if (giftRecipients.length < 1) {
				document.getElementById('viewRecipients').innerHTML = `
					<div class="bg-grey-lightest rounded border-grey grey-text center-align p-1 mt-4">
						Recipients will appear here.
						<!-- <p class="mt-0"><a href="#addRecipient" class="modal-trigger">Add Recipient</a></p> -->
					</div>
				`
				viewRecipients.addEventListener('click', e => addRecipientBtn.dispatchEvent(new Event('click')));
			}
			if (!allGifts.length) previewGiftTransfer.classList.add('disabled');
			renderNewGiftListeners();
			buildSelectRecipientOptions();
		});
		filterViewGT.addEventListener('change', function (e) {
			selectedClass = filterViewGT.value;
			showFilteredGiftTrans();
			if (selectedClass == "ALL") initializeDebtEquityTabs();	//viewEventsIconLarge.dispatchEvent(new Event('click'));
		});
		document.getElementById('showDecimals').addEventListener('change', function (e) {
			e.preventDefault();
			if (includedClasses.length > 1) {
				if (!selectedClass) selectedClass = "ALL";
				showFilteredGiftTrans();
			} else {
				showFilteredGiftTrans();
			}
		});
		if (newHoldingButton) newHoldingButton.addEventListener('click', function(e) {
			window.location.replace('/admin/ledgers/?action=newtransaction&recipient=' + encodeURIComponent(shareholder));
		});
		document.getElementById('exportGiftTransfer').addEventListener('click', function (e) {
			e.preventDefault();
			let trancheTableHtml = document.getElementById('trancheTable');
			let origTrancheTableHtml = trancheTableHtml.innerHTML;
			trancheTableHtml.innerHTML = trancheTableHtml.innerHTML.replace(/<p class="text-xxs font-md mt-1 mb-0">/g, ' | ');
			trancheTableHtml.innerHTML = trancheTableHtml.innerHTML.replace(/<p class="text-xxs mt-1 mb-0">/g, ' | ');
			trancheTableHtml.innerHTML = trancheTableHtml.innerHTML.replace(/<\/p>/g, '');
			trancheTableHtml.innerHTML = trancheTableHtml.innerHTML.replace(/<\/span><br>/g, '<\/span> | ');
			trancheTableHtml.innerHTML = trancheTableHtml.innerHTML.replace(/<br>/g, ' ');
			export_table_to_excel('historicalsSortTable|trancheTable', giftUserData.user_name + " Gift / Transfer Report (" + new Date().toLocaleString() + ").csv");
			// export_table_to_excel('historicalsSortTable|priorsSortTable|recipientsGiftTable', giftUserData.user_name + " Gift / Transfer Report (" + new Date().toLocaleString() + ").csv");
			trancheTableHtml.innerHTML = origTrancheTableHtml;
		});
		previewGiftTransfer.addEventListener('click', function(e) {
			if (fromUser) sendThisRequest();
			else renderTransactionMapTable();
		});
		if (historicalsSortTable) historicalsSortTable.addEventListener('click', async function (e) { // 🔹 Add `async`
			if (event.target.classList.contains('selectTrancheInput')) {
				let selected = e.target.getAttribute('data-tranche');
				let consolidate = document.getElementById("consolidate");
				let cbElem = document.getElementById('cbElem-' + selected);
				let imgElem = document.getElementById('imgElem-' + selected);
				let cbElems = document.querySelectorAll('.selectTrancheInput');

				if (selected == "all") {
					selectedTranches = [];
					if (e.target.checked) {
						currentData.forEach(u => selectedTranches.push(u.userid));
						document.querySelectorAll('input[type=checkbox]').forEach(el => {if (el.classList.contains("selectTrancheInput")) el.checked = true;});
					} else {
						document.querySelectorAll('input[type=checkbox]').forEach(el => {if (el.classList.contains("selectTrancheInput")) el.checked = false;});
					}
				} else {
					if (e.target.checked) {
						let thisClass = e.target.dataset.class;
						cbElem.style.display = 'block';
						imgElem.style.display = 'none';
						selectedTranches.push(selected);
						for (let i = 0; i < cbElems.length; i++) {
							if (cbElems[i].dataset.class != thisClass) cbElems[i].disabled = true;
							else cbElems[i].disabled = false;
						}
						addRecipientBtn.classList.add('text-secondary');
						addRecipientBtn.style.pointerEvents = 'none';
					} else {
						cbElem.style.display = 'none';
						imgElem.style.display = 'block';
						selectedTranches = selectedTranches.filter(function(tr) {
							return tr !== selected;
						});
					}
				}

				let trLen = selectedTranches.length;
				if (trLen == 0) {
					for (let i = 0; i < cbElems.length; i++) cbElems[i].disabled = false;
					addRecipientBtn.classList.remove('text-secondary');
					addRecipientBtn.style.pointerEvents = null;
				} else if (trLen == 1) {
					await getNextCertNumber();
					consolidate.innerHTML = "Reissue Tranche: " + (selectedTranches[0] || '');
					previewGiftTransfer.classList.remove('disabled');
					previewGiftTransfer.innerHTML = "Preview This Reissuance";
				} else if (trLen > 1) {
					await getNextCertNumber();
					selectedTranches.sort();
					consolidate.innerHTML = "Consolidate Tranches: " + (trLen > 1 ? `${selectedTranches.slice(0, -1).join(', ')} and ${selectedTranches[trLen - 1]}` : selectedTranches[0] || '');
					previewGiftTransfer.classList.remove('disabled');
					previewGiftTransfer.innerHTML = "Preview This Consolidation";
				} else {
					consolidate.innerHTML = "";
					previewGiftTransfer.classList.add('disabled');
					previewGiftTransfer.innerHTML = "Preview These Transfers";
				}
				console.log(selectedTranches);
			}
		});

		if (isAdmin) {
			const stepwiseControls = document.getElementById('stepwiseControls');
			const stepwiseCheckBox = document.getElementById('stepwiseCheckBox');
			stepwiseCheckBox?.classList.remove('hidden');
			if (stepwiseAnalysis) stepwiseAnalysis.addEventListener('change', function(e) {
				if (stepwiseAnalysis.checked) {
					balanceHeadline.classList.add('hidden');
					stepwiseControls.classList.remove('hidden');
					giftTransferControls.classList.add('hidden');
					showTrancheTable();

					// --- Step 2: Instantiate listeners once (no behavior yet) ---
					let _stepwiseBound = false;
					let _stepwisePaintLock = false; // simple re-entry guard for repaint

					function repaintGiftModal (reason) {
						if (_stepwisePaintLock) return; // avoid double-fires
						_stepwisePaintLock = true;
						try {
							console.log(`[stepwise] repaint due to: ${reason}`);
							builtGiftTransferModalAlready = false;
							giftTransfer(giftUserId, false); // 🔁 repaint entire modal
						} catch (err) {
							console.error("[stepwise] repaint error", err);
						} finally {
							setTimeout(() => { _stepwisePaintLock = false; }, 0);
						}
					}

					function initStepwiseListenersOnce () {
						if (_stepwiseBound) return; // idempotent
						const firstBtn = document.getElementById('stepFirst');
						const prevBtn  = document.getElementById('stepPrev');
						const nextBtn  = document.getElementById('stepNext');
						const lastBtn  = document.getElementById('stepLast');

						// Guard in case controls aren't in DOM yet
						if (!firstBtn || !prevBtn || !nextBtn || !lastBtn) return;

						const onClick = (name) => (e) => {
							e.preventDefault();
							// adjust target length
							if (name === 'First') window._stepwiseTargetLen = 1;
							else if (name === 'Prev') window._stepwiseTargetLen = Math.max(1, (window._stepwiseTargetLen || 1) - 1);
							else if (name === 'Next') window._stepwiseTargetLen = Math.min((window._stepwiseMasterLen || 1), (window._stepwiseTargetLen || 1) + 1);
							else if (name === 'Last') window._stepwiseTargetLen = (window._stepwiseMasterLen || 1);

							// repaint modal (your existing call)
							giftTransfer(giftUserId, false);
							showTrancheTable();
						};

						firstBtn.addEventListener('click', onClick('First'));
						prevBtn.addEventListener('click', onClick('Prev'));
						nextBtn.addEventListener('click', onClick('Next'));
						lastBtn.addEventListener('click', onClick('Last'));

						// Optional: keyboard hooks (Left/Right/Home/End) — logs only
						document.addEventListener('keydown', (e) => {
							if (e.key === 'Home')  return onClick('First')(e);
							if (e.key === 'ArrowLeft') return onClick('Prev')(e);
							if (e.key === 'ArrowRight') return onClick('Next')(e);
							if (e.key === 'Last')   return onClick('Last')(e);
						}, { passive: false });

						_stepwiseBound = true;
						console.log('[stepwise] listeners bound');
					}

					initStepwiseListenersOnce();
				} else {
					stepwiseControls.classList.add('hidden');
					balanceHeadline.classList.remove('hidden');
					giftTransferControls.classList.remove('hidden');
					window._stepwiseTargetLen = null; // set clamp set to end
					giftTransfer(giftUserId, false);  // repaint with full range
				}
			});		

			function showTrancheTable() {
				showHidePriorsDiv.classList.add('mb-2');
				showHidePriorsDiv.classList.remove('mb-0');
				document.getElementById('trancheTable').classList.remove('hidden');
				const showHide = document.getElementById('showHidePriors');
				if (showHide) showHide.innerText = "Hide Prior Tranches";
			}
		}

		function initializeDebtEquityTabs () {
			let instance = M.Tabs.init(debtEquityTabs, {});
			debtEquityTabs.classList.add('hidden');
			setTimeout(() => {
				if (showTabs) {
					debtEquityTabs.classList.remove('hidden');
					instance.updateTabIndicator();
					console.log("Intialized Debt-Equity tabs");
				}
			}, 100);
		}

		showHideZeros.dispatchEvent(new Event('click'));
		renderGiftRecipients();

		const removeThisRequest = document.getElementById('removeThisRequest');
		const shareholderTransferRequests = shareholderData.clients[client].transfer_requests || {};

		// Extract all gifts that are "Open"
		const openGifts = Object.values(shareholderTransferRequests)
			.flat() // Flatten nested arrays
			.filter(gift => gift.status === "Open");

		if (openGifts.length > 0) {
			removeThisRequest.classList.remove('hidden');

			allGifts = openGifts;
			renderNewGiftListeners();
			getNextCertNumber();

			// Extract unique recipients
			const uniqueRecipients = new Set(allGifts.map(gift => gift.receiver));

			// Fire events for each unique recipient
			uniqueRecipients.forEach(recipientId => { // 🔹 Add `async`
				let recip = capTableData.find(u => u.userid == recipientId);
				if (!recip) {
					alert("⛔ Missing recipient account: " + recipientId + ".\n\n⚠️ Please add this account to the cap table before continuing.");
					return;
				}
				if (!giftRecipients.find(r => r.userid == recipientId)) giftRecipients.push(recip);
				// await getNextCertNumber();
				renderGiftRecipients();
				renderNewGiftListeners();
				buildSelectRecipientOptions();
				document.getElementById(recip.userid + 'AddGift').dispatchEvent(new Event('click'));
			});

			// Adjust balances based on gifts
			allGifts.forEach(g => adjustBalances(Number(g.quantity), g.receiver, g.tranche));

			// Add event listeners for request removal
			document.getElementById('removeThisRequest').addEventListener('click', function (e) {
				M.Modal.getInstance(confirmRequestRemove).open();
			});
			document.getElementById('removeRequestBtn').addEventListener('click', function (e) {
				M.Modal.getInstance(viewGiftTransferModal).close();
				M.Modal.getInstance(confirmRequestRemove).close();
				M.Modal.getInstance(statementWaitState).open();
				clearPendingRequests("Removed");
			});
		} else {
			removeThisRequest?.classList.add('hidden');
		}
	}

	let labelBB = clientData.language?.label_buy_back?.includes("Redemption") ? "Redemption" : "Buy-Back";

	if (BUY_BACK) {
		let treasuryAccount = clientData.treasury_account;
		if (!treasuryAccount) treasuryAccount = "Treasury | temp_treasury@" + client + ".com";
		holders.push(treasuryAccount);
		treasuryId = treasuryAccount.split("|")[1].trim();
		let treasuryName = treasuryAccount.split("|")[0].trim();
		members = [{ userid: treasuryId, user_name: treasuryName, clients: { [client]: {shares: {}} } }];
		buildSelectRecipientOptions();
		selectRecipient.value = treasuryAccount;
		selectRecipient.dispatchEvent(new Event('change'));

		// now do these
		addRecipientBtn.classList.add('hidden');
		totalCurrentValueDiv.classList.remove('hidden');
		previewGiftTransfer.innerHTML = "Request This " + labelBB;
		document.getElementById('toTheseRecipientsDiv').classList.add('hidden');
		document.getElementById('requestHeadline').classList.remove('hidden');		
		document.getElementById('requestInstructions').classList.remove('hidden');
		totalCurrentValueDiv.innerHTML = `Total Current Value${isEDM ? ` (${currentPrice("C")?.toLocaleString('en-US', usd)} per share)` : ``}:&ensp;<span id="totalCurrentValue" class="text-black"></span>`;
		const firstTranche = document.getElementById(' |' + treasuryId + '|TrancheId');
		if (firstTranche) setTimeout(() => { firstTranche.focus(); }, 10);
	} else if (capTableData && !fromUser) {	// <-- 2/10/2025 added !fromUser to more accurately preview user experience
		capTableData.forEach(function (i) {
			if (i.userid == giftUserId) return;
			if ((isBB && !client == "onwardfe") || i.user_name.includes('|')) holders.push(i.user_name);
			else holders.push(i.user_name + " | " + i.userid);
		});
		// capTableData.forEach(function (i) { if (i.userid != giftUserId) holders.push((i.clients[client].notes ? (i.clients[client].notes + "\xa0\xa0|\xa0\xa0") : "") + i.user_name); });
		// capTableData.forEach(function (i) { if (i.userid != giftUserId) holders.push(i.user_name + "\xa0\xa0|\xa0\xa0" + i.userid); });
		// capTableData.forEach(function (i) { holders.push(i.user_name); });
		holders.sort();
		buildSelectRecipientOptions();
	} else {	// regular user needs members
		addRecipientBtn.classList.add('text-secondary');
		addRecipientBtn.style.pointerEvents = 'none';
		addRecipientBtn.innerHTML = '<i class="material-icons align-middle mb-1 mr-05">person_add</i>One moment...';
		axios.post('https://api.nthround.io/portal/user/alias-names',
			JSON.stringify({
				alias_list: [],  // workspaces are trust accounts
				client: client,
				userid: authedUser,
				cookie: cookie
			})
		).then(function(res) {
			addRecipientBtn.classList.remove('text-secondary');
			addRecipientBtn.style.pointerEvents = null;
			addRecipientBtn.innerHTML = '<i class="material-icons align-middle mb-1 mr-05">person_add</i>Add Recipient';
			members = removeNthAdmins(res.data);

			// Family Filter for USV
			const FF = isUSV || client == "onwardfe";
			const sliceFF = isUSV ? 1 : 2;
			const familyCode = userData.clients[client]?.tags?.[0]?.slice(0, sliceFF) || "";
			if (FF && fromUser && familyCode) members = members.filter(r => r.tags?.[0]?.slice(0, sliceFF) === familyCode);

			members.forEach(function (i) {
				if (i.userid == giftUserId) return;
				if ((isBB && !client == "onwardfe") || i.user_name.includes('|')) holders.push(i.user_name);
				else holders.push(i.user_name + " | " + i.userid);
			});
			holders.sort();
			buildSelectRecipientOptions();
		})
		.catch(function(error) {
			console.error(error);
		});
	}

	function showTotals () {
		ttlAfter = 0;
		ttlBefore = 0;
		ttlBasis = 0;
		let len = giftTransactions.length;	//historicHoldings.length;
		if (len < 1) return;
		for (let i = 0; i < len; i++) {
			ttlBefore += Number(giftTransactions[i].before);
			ttlAfter += giftTransactions[i].after != null ? giftTransactions[i].after : Number(giftTransactions[i].quantity);
			if (isNaN(ttlBasis) || isNaN(giftTransactions[i].sharePrice) || giftTransactions[i].sharePrice == "") ttlBasis = "n.a.";
			else ttlBasis += Number(giftTransactions[i].quantity) * toNumber(giftTransactions[i].sharePrice);
		}
		let totals = "ttlBefore = " + ttlBefore + " | ttlAfter = " + ttlAfter;
		console.log(totals);
		let trancheLog = localStorage.getItem('TrancheLog');
		trancheLog += "\n" + totals;
		localStorage.setItem('TrancheLog', trancheLog);
		// if (balanceBefore != ttlBefore) alert("#### NOT EQUAL ####");
		document.getElementById('totalBefore').innerHTML = ttlBefore.toLocaleString('en-US', stringOptions);
		document.getElementById('totalAfter').innerHTML = ttlAfter.toLocaleString('en-US', stringOptions);
		document.getElementById('avgCostBasis').innerHTML = isNaN(ttlBasis) ? "n.a." : (ttlBasis / ttlAfter).toLocaleString('en-US', usd);
	}

	function buildSelectRecipientOptions () {
		let recips = [];
		selectRecipient.options.length = 1;
		giftRecipients.forEach(r => recips.push(r.user_name));
		// giftRecipients.forEach(r => recips.push((r.clients[client].notes ? (r.clients[client].notes + "\xa0\xa0|\xa0\xa0") : "") + r.user_name));
		selectRecipient.options[1] = new Option("Issuer | Cancellation or Redemption", "Issuer");
		holders.forEach(h => { if (!recips.includes(h)) selectRecipient.options[selectRecipient.options.length] = new Option(h, h) } );
		var options = {
			dropdownOptions: {
				container: 'authed',	// Renders the dropdown in the authed div
				coverTrigger: false		// Ensures dropdown stays open over the modal
			}
		};
		var selects = document.querySelectorAll('select');
		var instances = M.FormSelect.init(selects, options);
	}

	function renderGiftRecipients () {
		let recipientsMarkup = '';
		let emptyState = `
			<div class="bg-grey-lightest rounded border-grey grey-text center-align p-1 mt-4">
				Recipients will appear here.
				<!-- <p class="mt-0"><a href="#addRecipient" class="modal-trigger">Add Recipient</a></p> -->
			</div>
		`

		let index = giftRecipients.length - 1;
		if (index < 0) {
			recipientsMarkup = emptyState;
		} else {
			let recipOwned = 0;
			let recip = giftRecipients[index];
			let recipClientData = recip.clients ? recip.clients[client] : recip;
			let recipNotes = recip.clients ? recip.clients[client].notes : recip.notes;
			classes.forEach(c => recipOwned += Number(recipClientData.shares?.[c]?.owned || "0"));
			giftRecipients[index].before = recipOwned;
			giftRecipients[index].after = recipOwned;

			recipientsMarkup = `
				<div id="${recip.userid}|Div" class="recip-div card px-4 mt-4 mb-0 rounded">
					${BUY_BACK ? `` : `<div class="row center-align mt-0 mb-0">
						<!-- <div class="col s12 m6 left-align mt-2" title="${recip.friendly_name ? (recip.userid + " [" + recip.friendly_name.replace(/_/g, ' ') + "]") : 
							recip.userid}">${(recipNotes ? (recipNotes + "\xa0\xa0|\xa0\xa0") : "") + recip.user_name}</div> -->
						<div class="col s12 m6 left-align mt-2" title="${recip.userid}">${recip.user_name}</div>
						<div class="text-sm text-secondary col s12 m5 mt-2 right-align">Shares Owned:&emsp;<span class="text-primary">${recip.before.toLocaleString()}</span>&nbsp;Before&emsp;
							<span id="${recip.userid}|After" class="text-primary">${recip.after.toLocaleString()}</span>&nbsp;After</div>
						<a href="#confirmRecipientRemove" class="col s12 m1 modal-trigger remove-gift-recipient waves-effect waves-red btn-flat red-text text-xxs right" data-key="${recip.userid}">Remove</a>
					</div>`}
					<div id="${recip.userid}Gifts"></div>
					<div class="flex center-align mb-0 hidden">
						<p class="text-xs mt-2 mb-0 left"><a id="${recip.userid}AddGift" href="#" class="add-recip text-sm" data-key="${recip.userid}">+ Add Gift/Transfer</a></p>
						<a href="#confirmRecipientRemove" class="col s12 m1 modal-trigger remove-gift-recipientHIDDEN waves-effect waves-red btn-flat p-0 mt-2 mb-0 right" data-key="${recip.userid}">Remove</a>
					</div>
				</div>
			`;
		}

		let viewRecipients = document.getElementById('viewRecipients');
		if (index == 0) viewRecipients.innerHTML = recipientsMarkup;
		else viewRecipients.innerHTML += recipientsMarkup;
		// viewRecipients.addEventListener('click', e => addRecipientBtn.dispatchEvent(new Event('click')));
	}

	function renderNewGiftListeners () {
		document.querySelectorAll('.add-recip').forEach(recip => {
			// console.log("ADDED add-recip", recip);
			recip.addEventListener('click', function (e) {
				currentTranche = "";
				recipientId = e.target.dataset.key;
				let recipient = capTableData ? capTableData.find(u => u.userid == recipientId) : members.find(u => u.userid == recipientId);	// for regular users, not admins
				recipientName = recipientId == "issuer" ? clientData.company_name : recipient ? recipient.user_name : "UNKNOWN";

				theseGifts = {};
				let giftArray = allGifts.filter(g => g.receiver == recipientId);
				giftArray.forEach(g => theseGifts[g.tranche] = g);
				// theseGifts[" "] = ["","",,];
				if (!theseGifts.length) theseGifts[" "] = ["","",,];
				gifts = Object.keys(theseGifts);

				const HIDE_COST_BASIS = BUY_BACK && isEDM;
				const ce = BUY_BACK ? '' : 'contenteditable';
				let giftTable = document.getElementById(recipientId + 'Gifts');
				let giftTableMarkup = `
					${gifts.length ? `
						<div class="table-wrap mb-0">
							<div class="sm-hz-scroll-no-margin">
								<table id="recipientsGiftTable" class="recip-table highlight table-content">
									<thead>
										<tr class="text-xs">
											<th class="center-align p-05">Tranche</th>
											${CLASS_COLUMN ? `<th class="center-align -05">Class</th>` : ``}
											<th class="center-align p-05">Date</th>
											<!-- <th class="sm-fixed-left p-05">Notes</th> -->
											<th class="sm-fixed-left p-05">Description</th>
											<th id="qtyHeader|${recipientId}" class="center-align p-05">Quantity</th>
											${HIDE_COST_BASIS ? `` : `<th class="center-align p-05">Cost&nbsp;Basis</th>`}
											<th class="center-align p-05">Current Value</th>
										</tr>
									</thead>
									<tbody>
									${gifts.map((gift, index) => `
										<tr id="${gift + '|' + recipientId + '|'}Tranche" class="add-tranche">
											<td id="${gift + '|' + recipientId + '|'}TrancheId"
												class="new-tranche text-xs center-align font-bold p-05" contenteditable style="${index === gifts.length - 1 ? 'outline: 1px solid rgba(0,0,0,0.1); outline-offset: -1px; background-color: #ffffcc;' : ''}">
												${gift}
											</td>
											${CLASS_COLUMN ? `
											<td class="text-xs center-align p-05">
												${theseGifts[gift].shareClass ? theseGifts[gift].shareClass : ''}
											</td>` : ``}
											<td id="editableDate-${gift}" class="gift-date text-xs center-align p-05" ${ce} ${isAdmin ? '' : 'title="Must be within the next 60 days."'}>
												${theseGifts[gift].date ? moment.unix(theseGifts[gift].date / 1000).format("MMM D, YYYY") : ''}
											</td>
											<!-- <td id="editablePre-${gift + '|' + recipientId}" class="select-notes text-xs sm-fixed-left p-05" ${ce}>
												${theseGifts[gift].pre ? theseGifts[gift].pre : ''}
											</td> -->
											<td id="editableNotes-${gift}" class="text-xs sm-fixed-left p-05" title="${gift}" ${ce}>
												${theseGifts[gift].notes ? theseGifts[gift].notes.replace(/_/g, ' ') : ''}
											</td>
											<td id="${recipientId + '|' + gift}-tranche" class="gift-qty text-xs center-align p-05" contenteditable>
												${theseGifts[gift].quantity ? Number(theseGifts[gift].quantity).toLocaleString('en-US', stringOptions) : ''}
											</td>
											${HIDE_COST_BASIS ? `` : `<td id="editablePrice-${gift}" class="select-gift text-xs center-align p-05" ${isAdmin ? ce : ''}>
												${theseGifts[gift].sharePrice && !isNaN(theseGifts[gift].sharePrice.replace(/[^.\d]/g, '')) ? (Number(theseGifts[gift].sharePrice.replace(/[^.\d]/g, ''))).toLocaleString('en-US', usp) : gift.trim() ? 'n.a.' : ''}
											</td>`}
											<td id="currentValue-${gift + '|' + recipientId}" class="text-xs center-align p-05">
												${!theseGifts[gift].quantity ? "" : isNaN(currentPrice(theseGifts[gift].shareClass)) ? "n.a." : (Number(theseGifts[gift].quantity) * currentPrice(theseGifts[gift].shareClass)).toLocaleString('en-US', usd)}
											</td>
										</tr>
										`
									).join('')}
									</tbody>
								</table>
							</div>
						</div>
						` : `
						<div class="bg-grey-lightest rounded border-grey grey-text center-align p-2">
							No gifts found
						</div>
						`
					}
				`;

				giftTable.innerHTML = giftTableMarkup;

				// scroll to bottom
				viewGiftTransferModal.scrollTop = viewGiftTransferModal.scrollHeight;

				renderTrancheListeners();

				let newTranche = document.getElementById(' |' + recipientId + '|Tranche');
				if (gifts.length > 1) newTranche.focus()
				// Should automatically inject new tranche if only one possibility, but...
				// else if (historicHoldings.length == 1) {
				// 	newTranche.children[0].innerHTML = "A";
				// 	let thisTranche = document.querySelectorAll('.new-tranche')[0];
				// 	thisTranche.dispatchEvent(new Event('keyup'));
				// }
				else newTranche.children[0].focus();
			});
		});

		// document.querySelectorAll('.recip-div').forEach(table => {
		// 	console.log("ADDED recip-div", table);
		// 	table.addEventListener('focusin', function(e) {
		// 		recipientId = e.target.id.split('|')[0];
		// 		console.log("table focus, recipientId = " + recipientId);
		// 	});
		// });

		document.querySelectorAll('.remove-gift-recipient').forEach(remove => {
			// console.log("ADDED remove-gift-recipient", remove);
			remove.addEventListener('click', function(e) {
				e.preventDefault();
				removeGiftId = e.target.getAttribute("data-key");
				let recipientRemoveName = document.getElementById('recipientRemoveName');
				recipientRemoveName.innerHTML = e.target.parentElement.innerText.split('Shares Owned:')[0].trim();
			});
		});

		function renderTrancheListeners() {
			// let trancheId = (currentTranche ? currentTranche : ' ') + '|' + recipientId + '|Tranche';
			// let tranche = document.getElementById(trancheId);

			document.querySelectorAll('.add-tranche').forEach(tranche => {
				// console.log("ADDED add-tranch", tranche);
				tranche.addEventListener('focusin', function(e) {
					currentTranche = this.children[0] ? this.children[0].innerText.trim().toUpperCase() : this.innerText.trim().toUpperCase();
					recipientId = this.id.split('|')[1];
					// console.log("tranche focusin, recipientId = " + recipientId);
				});
				tranche.addEventListener('keyup', function(e) {
					let thisTranche = this.children[0] ? this.children[0].innerText.trim().toUpperCase() : this.innerText.trim().toUpperCase();
					let onTarget = e.target.id.endsWith('|TrancheId');
					if (!thisTranche && !onTarget) {
						e.target.innerText = '';
						return;
					}
					if (!thisTranche) {
						let thisQty = document.getElementById(recipientId + '|' + currentTranche + '-tranche');
						thisQty = thisQty ? thisQty.innerText : null;
						if (thisQty) {
							adjustBalances(-Number(thisQty.replace(/[^-.\d]/g, '')), recipientId, currentTranche);
							allGifts = allGifts.filter(g => g.receiver != recipientId || g.tranche != currentTranche);
							document.getElementById(recipientId + 'AddGift').dispatchEvent(new Event('click'));
							renderNewGiftListeners();
							if (isVERM) checkVermeerRule(recipientId);
						}
						return;
					}
					
					// check it thisTranche is available and not ambiguous
					let priorTranches = priorTransfers.map(t => t.tranche);
					let availableTranches = giftTransactions.filter(t => Number(t.quantity) != 0).map(t => t.tranche);
					availableTranches = availableTranches.filter(function(a) {
						let thisHH = giftTransactions.find(h => h.tranche == a);
						let balance = thisHH ? Number(thisHH.quantity) : 0;
						return !priorTranches.includes(a) || balance > 0;
					});
					let applicableTranches = availableTranches.filter(a => a.startsWith(thisTranche));
					if (onTarget) {
						if (applicableTranches.length == 1) thisTranche = applicableTranches[0];
						else if (applicableTranches.length > 1 && e.code != "Tab" && e.code != "Enter") return;
					}

					gifts = allGifts.filter(g => g.receiver == recipientId).map(g => g.tranche);
					gifts.push(" ");
					if (onTarget && (gifts.includes(thisTranche) || !availableTranches.includes(thisTranche))) {
						if (this.children[0]) this.children[0].innerHTML = "";
						else this.innerHTML = "";
						return;
					}

					// 3-27-2024 Just brought back the || Tab bit.  Not sure why it was commented out, but without it, Tranche A fails with Christopher Vermeer Living Trust (more than 26 available tranches).
					// 7-16-2025 Commented back out the tab bit.  On edit share count, then tab, it incorrectly invokes recalculation.
					if (onTarget) {	//} || e.code == "Tab") {
						this.innerHTML = thisTranche;
						gifts.splice(-1, 0, thisTranche);
						let thisTrans = giftTransactions.find(t => t.tranche == thisTranche);
						if (thisTrans) {
							let qtyTrans = thisTrans.quantity;
							let qtyAfter = document.getElementById('quantity' + thisTranche).innerHTML
							if (qtyAfter) qtyTrans = Number(qtyAfter.replace(/[^-.\d]/g, '')).toString();
							// Use prior quantity rather than remaining balance, if available and new recipient
							if (allGifts.length && recipientId != allGifts[allGifts.length-1].receiver) {
								let priorQty = Number(allGifts[allGifts.length-1].quantity);
								let availQty = Number(qtyTrans);
								if (availQty >= priorQty) qtyTrans = priorQty.toString();
							}
							let newDate = allGifts.length ? allGifts[allGifts.length-1].date : Date.now().toString();
							let newNotes = labelBB + " (" + thisTrans.notes.trim() + " dated " + moment.unix(thisTrans.date).format('M/D/YY') + ")";
							if (thisTrans.certNumber) newNotes = labelBB + " (" + thisTrans.certNumber +")";
							if (!BUY_BACK) {
								if (recipientId != "issuer") {
									if (CERT_COLUMN) {
										const transClass = thisTrans.shareClass;
										const nextCert = nextCertNum[transClass];
										const lastCert = lastCertNum[transClass];
										newNotes = nextCert ? "Transfer (" + nextCert + ")" : "Transfer";
										const lastCertNumber = document.getElementById('lastCertNumber');
										lastCertNumber.innerHTML = lastCert ? "Last certificate number: " + lastCert : "";
										lastCertNumber.classList.remove('hidden');
										incrementNextCertNumber(transClass);
									} else {										
										newNotes = "Transfer (" + thisTrans.notes.trim() + " dated " + moment.unix(thisTrans.date).format('M/D/YY') + ")";
									}
								}
								if (isBB) {
									let firstWord = thisTrans.notes.split(' ')[0];
									let dateStart = Number.isInteger(Date.parse(firstWord)) || ['jan','feb','mar','apr','may','jun','jul','aug','sep','oct','nov','dec'].some(m => firstWord.toLowerCase().startsWith(m));
									newNotes = "Gift from " + (giftUserData.user_name.includes('|') ? giftUserData.user_name.split('|')[1].trim() : giftUserData.user_name.trim()) + " - " + 
										moment.unix(thisTrans.date).format('M/D/YY') + " " + (dateStart ? '| ' : '') + thisTrans.notes.trim();
								}								
							}

							// 5-18-2025 USV does not explictly track tranches (cancel/resissue stubs) so tranche analysis falls apart
							// the reciever fro thisTrans likely will not be teh current shareholder, which is a big problem
							theseGifts[thisTranche] = {
								tranche: thisTranche,
								shareClass: thisTrans.shareClass,
								securityType: thisTrans.securityType,
								date: newDate,
								notes: newNotes,
								sender: shareholder,	//thisTrans.receiver,
								senderName: nameWithOverride(shareholder),	//thisTrans.receiverName,
								receiver: recipientId,
								receiverName: recipientName,
								quantity: qtyTrans,
								sharePrice: thisTrans.sharePrice
							}

							allGifts.push(theseGifts[thisTranche]);
							previewGiftTransfer.classList.remove('disabled');
							adjustBalances(Number(qtyTrans.replace(/[^-.\d]/g, '')), recipientId, thisTranche);
							document.getElementById(recipientId + 'AddGift').dispatchEvent(new Event('click'));
							// document.getElementById('editablePre-' + gifts[gifts.length - 2] + '|' + recipientId).focus();
							if (isVERM) checkVermeerRule(recipientId);
						}
					} else {
						let i = allGifts.findIndex(g => g.receiver == recipientId && g.tranche == thisTranche);
						if (i < 0) alert("Receiver not found");
						switch (e.target.id.split('-')[0]) {
							case 'editableDate': allGifts[i].date = Date.parse(e.target.innerText).toString(); break;
							// case 'editablePre': allGifts[i].pre = e.target.innerText; break;
							case 'editableNotes': allGifts[i].notes = e.target.innerText; break;
							case 'editablePrice': allGifts[i].sharePrice = Number(e.target.innerText.replace(/[^-.\d]/g, '')).toLocaleString('en-US', usp); break;
						}
					}
				});
			});

			document.querySelectorAll('.gift-date').forEach(dateElem => {
				dateElem.addEventListener('blur', function () {
					const rawText = this.innerText.trim();

					let parsed = moment(rawText, [
						"MMMM D, YYYY", "MMM D, YYYY",
						"M/D/YYYY", "M-D-YYYY",
						"YYYY-MM-DD"
					], true);

					const today = moment().startOf('day');
					const maxDate = moment().add(60, 'days').startOf('day');

					// Replace junk or empty with today
					if (!parsed.isValid()) parsed = today;

					// Clamp to range
					if (!isAdmin) {
						if (parsed.isBefore(today)) parsed = today;
						if (parsed.isAfter(maxDate)) parsed = maxDate;
					}

					// Update display
					this.innerText = parsed.format("MMMM D, YYYY");
				});
			});

			let origQuantity;
			let newQuantity;
			document.querySelectorAll('.gift-qty').forEach(qty => {
				if (gifts.length > 1 && recipientId != qty.id.split('|')[0]) return;
				// console.log("ADDED gift-qty", qty);
				qty.addEventListener('focus', function(e) {
					// console.log("focus", e.target.id);
					recipientId = this.id.split('|')[0];
					// console.log("qty focus, recipientId = ", recipientId);
					let thisElem = document.getElementById(this.id);
					origQuantity = Number(thisElem.innerHTML.replace(/[^-.\d]/g, ''));
					if (origQuantity == 0) thisElem.innerHTML = "";
					// console.log("qty focus, origQuantity = ", origQuantity);
				});
				qty.addEventListener('blur', function(e) {
					let thisElem = document.getElementById(this.id);
					origQuantity = Number(thisElem.innerHTML.replace(/[^-.\d]/g, ''));
					thisElem.innerHTML = origQuantity.toLocaleString('en-US', stringOptions);
					// console.log("qty focus, origQuantity = ", origQuantity);
				});
				qty.addEventListener('input', function(e) {
					let targetTranche = this.id.split('|')[1].replace('-tranche', '');
					let maxQuantity = Number(giftTransactions.find(g => g.tranche == targetTranche).quantity);
					// console.log("input", e.target.id);
					let thisElem = document.getElementById(this.id);
					let newText = thisElem.innerHTML.replace(/[^-.\d]/g, '');
					newQuantity = Number(newText);
					thisElem.innerHTML = newQuantity || newText.includes(".") || newText == "0" ? newText : "";
					document.getSelection().collapse(this, this.childNodes.length);
					if (newQuantity > maxQuantity || newQuantity < 0) {
						newQuantity = maxQuantity;
						thisElem.innerHTML = newQuantity ? newText : "";
						document.getSelection().collapse(this, this.childNodes.length);
					}
					// console.log("qty input, newQuantity = ", newQuantity);
					let difference = newQuantity - origQuantity;
					adjustBalances(difference, recipientId, targetTranche);
					// allGifts
					let thisGiftIndex = allGifts.findIndex(g => g.receiver == recipientId && g.tranche == targetTranche);
					if (thisGiftIndex >= 0) allGifts[thisGiftIndex].quantity = newQuantity.toString();
					let correntValueElem = document.getElementById("currentValue-" + targetTranche + '|' + recipientId);
					let newPrice = currentPrice(allGifts[thisGiftIndex].shareClass);
					correntValueElem.innerHTML = isNaN(newPrice) ? "n.a." : (newQuantity * newPrice).toLocaleString('en-US', usd);
					origQuantity = newQuantity;
					if (isVERM) checkVermeerRule(recipientId);
				});
			});
		}
	}

	function adjustBalances (adjustment, recipient, tranche) {
		if (isNaN(adjustment)) adjustment = 0;
		// TO headline
		console.log("adjustBalances: ", adjustment, recipient, tranche);
		let thisRecip = giftRecipients.find(r => r.userid == recipient);
		if (thisRecip) {
			thisRecip.after += adjustment;
			if (!BUY_BACK) document.getElementById(recipient + '|After').innerHTML = thisRecip.after.toLocaleString('en-US', stringOptions);
		}

		// FROM headline
		balanceAfter -= adjustment;
		document.getElementById('balanceAfterElem').innerHTML = balanceAfter.toLocaleString('en-US', stringOptions);

		// FROM table
		let quantityTranche = document.getElementById('quantity' + tranche);
		let quantityBefore = Number(quantityTranche.innerHTML.replace(/[^-.\d]/g, ''));
		let quantityAfter = quantityBefore - adjustment;
		quantityTranche.innerHTML = quantityAfter.toLocaleString('en-US', stringOptions);
		if (quantityAfter < 0) {
			quantityTranche.classList.add('red-text');
			quantityTranche.classList.add('font-bold');
			previewGiftTransfer.classList.add('disabled');
		} else {
			quantityTranche.classList.remove('red-text');
			quantityTranche.classList.remove('font-bold');
			previewGiftTransfer.classList.remove('disabled');
		}

		// FROM total footer
		if (toggle != "Show Zeros") {
			ttlAfter -= adjustment;
			document.getElementById('totalAfter').innerHTML = ttlAfter.toLocaleString('en-US', stringOptions);
		}

		let thisShareClass = allGifts.find(g => g.receiver === recipient && g.tranche === tranche).shareClass;
		let price = currentPrice(thisShareClass);
		let totalCurrentValue = document.getElementById('totalCurrentValue');	// need re-rendered element
		if (!isNaN(price)) ttlCurrentValue = ttlCurrentValue === "n.a." ? 0 : ttlCurrentValue, ttlCurrentValue += adjustment * price;
		totalCurrentValue.innerHTML = isNaN(ttlCurrentValue) ? "n.a." : ttlCurrentValue.toLocaleString('en-US', usd);
		totalCurrentValueDiv.classList.remove('hidden');

		// resize modal
		document.getElementById('viewGiftTransferModal').style.overflowY = "auto";
	}	

	function currentPrice (shareClass) {
		let classVals = clientData.equity[shareClass].valuations;
		classVals.sort((a, b) => Number(b.date) - Number(a.date)); // newest to oldest
		if (!classVals?.[0]) return "n.a.";
		return Number(classVals[0].sharePrice.replace(/[^.\d]/g, ''));
	}

	async function getNextCertNumber () {
		if (!nextCertNum) {
			lastCertNum = {};
			nextCertNum = {};
			if (EXTERNAL_DATA) {
				let dataFileUrl = "https://d333hapirgneg8.cloudfront.net/" + client + "/";
				const dataFile = clientData.transactions_data ? clientData.transactions_data : "";
				if (!dataFile) return;
				else dataFileUrl += dataFile;
				try {
					const response = await fetch(dataFileUrl); // 🔹 Ensure fetch waits
					console.log(response);
					const results = await response.text(); // 🔹 Ensure text conversion waits
					// NOTE BENE (3/9/2025): External Data may or may not have a dedicated Certificate column. Painful...
					const data = Papa.parse(results).data;
					const certColumn = data[0][3].toLowerCase().startsWith("cert");
					CERT_COLUMN ||= data.some(row => row[3]?.includes('#'));
					if (CERT_COLUMN || certColumn) {
						classes.forEach(c => {
							nextCertNum[c] = "";
							let highestCertNum = 0;
							let classData = data.filter(d => d[0] == c);
							classData = classData.filter(row => row[3]?.includes('#') || row[4]?.includes('#'));
							classData.forEach(row => {								
								[3, 4].forEach(index => {	// Check only columns 3 and 4
									let cell = row[index];
									if (cell.includes('#')) {
										let match = getCertNumber(cell);
										if (match) {
											let certString = `#${match[2]}`; // Full matched cert (e.g., "#PA-22")
											// Extract numeric portion from certificate (e.g., "22" from "#PA-22")
											let numMatch = certString.match(/(\d+)/);
											if (numMatch) {
												let certNum = Number(numMatch[1], 10);
												if (certNum > highestCertNum) {
													highestCertNum = certNum;
													nextCertNum[c] = certString; // Store full certificate string
												}
											}
										}
									}
								});

							});
							incrementNextCertNumber(c);
						});
					}
				} catch (err) {
					console.warn('Something went wrong.', err);
				}
			} else {
				let clientEquity = clientData.equity;
				for (let c in clientEquity) {
					let transactions = clientEquity[c].transactions;
					nextCertNum[c] = "#" + transactions.reduce((maxCertNum, transaction) => {
						let match = transaction.notes.match(/\(#(\d+)\)/);
						let certNumber = match ? Number(match[1]) : 0;
						return Math.max(maxCertNum, certNumber);
					}, 0); // Start from 1 above the highest certificate number
					incrementNextCertNumber(c);
				}
			}
		}
	}

	function incrementNextCertNumber (c) {
		lastCertNum[c] = nextCertNum[c];
		const certNumber = getCertNumber(nextCertNum[c]);
		if (certNumber && certNumber[2]) {
			let newNumber;
			const whole = certNumber[2];
			const suffix = whole.split('-')[1];
			if (suffix) newNumber = suffix.replace(/[^\d.]/g, '');
			else newNumber = whole.replace(/[^\d.]/g, '');
			if (isNaN(newNumber)) nextCertNum[c] = "";
			else nextCertNum[c] = certNumber[0].replace(newNumber, Number(newNumber) + 1);
		} else nextCertNum[c] = "";
	}

	function checkVermeerRule (recipient) {
		let header = document.getElementById("qtyHeader|" + recipient);
		let recipGifts = allGifts.filter(g => g.receiver == recipient);
		if (!recipGifts) {
			header.innerHTML = 'Quantity';
			return;
		}
		let qtyClassE = recipGifts.filter(g => g.shareClass == "E").reduce((a, b) => a + Number(b.quantity), 0);
		let qtyOther = recipGifts.filter(g => ["V","NV"].includes(g.shareClass)).reduce((a, b) => a + Number(b.quantity), 0);
		if (qtyClassE == qtyOther) header.innerHTML = 'Quantity';
		else header.innerHTML = '<span class="orange-text" title="E != V + NV">⚠</span> Quantity';
		console.log("header.innerHTML = " + header.innerHTML);
	}

	function renderTransactionMapTable () {
		let rowErrors;
		giftSources = [];
		let badDataCounter = 0;
		let importTransCounter = 0;
		let importGiftTransferMarkup;
		// need new object
		let importTransMap = JSON.parse(JSON.stringify(allGifts));
		let importTransTarget = importTransMap.length;

		const CANCEL_REISSUE = CERT_COLUMN;	//isVERM;	// need for Ausable and Etnyre too.  Maybe Lucas??

		if (CANCEL_REISSUE) {
			let uniqueTranches = [...new Set(importTransMap.map(item => item.tranche))];
			uniqueTranches.forEach((t) => {
				let theseSources = giftTransactions.filter(g => g.tranche == t);
				if (theseSources.length != 1) alert("Gift source issue.");
				const giftSource = theseSources[0];
				giftSources.push(giftSource);
				const giftDate = importTransMap.find(i => i.tranche == t).date;
				const trancheSum = importTransMap.filter(i => i.tranche == t).reduce((acc, j) => acc + Number(j.quantity), 0);
				const stubAmount = Number(giftSource.quantity) - trancheSum;
				const nextCert = nextCertNum[giftSource.shareClass];
				if (stubAmount > 0) {
					// create two more transactions: a cancellation and a reissue
					let cancellation = {
						tranche: t,
						shareClass: giftSource.shareClass,
						securityType: giftSource.securityType,
						date: giftDate,
						notes: giftSource.certNumber ? "Stock Certificate Cancellation (" + giftSource.certNumber + ")" : "Stock Certificate Cancellation",
						sender: giftSource.receiver,
						senderName: giftSource.receiverName,
						receiver: "",
						receiverName: "Issuer",
						quantity: stubAmount.toString(),
						sharePrice: giftSource.sharePrice
					}

					let reissuance = {
						tranche: t,
						shareClass: giftSource.shareClass,
						securityType: giftSource.securityType,
						date: giftDate,
						notes: nextCert ? "Stock Certificate Reissuance (" + nextCert + ")" : "Stock Certificate Reissuance",
						sender: "",
						senderName: "Issuer",
						receiver: giftSource.receiver,
						receiverName: giftSource.receiverName,
						quantity: stubAmount.toString(),
						sharePrice: giftSource.sharePrice
					}

					let insertPoint = 0;
					for (let i = importTransMap.length - 1; i >= 0; i--) {
						if (importTransMap[i].tranche == t) {
							insertPoint = i;
							break;
						}
					}

					importTransMap.splice(insertPoint + 1, 0, cancellation);
					importTransMap.splice(insertPoint + 2, 0, reissuance);
					// nextCertNum[giftSource.shareClass]++;
				}
			});
		}

		if (selectedTranches.length > 0) {
			let reason = selectedTranches.length > 1 ? "Stock Certificate" : "Stock Certificate";
			let grossQty = 0;
			let grossDollars = 0;
			importTransMap = [];
			selectedTranches.sort();
			selectedTranches.forEach(t => {
				let giftSource = giftTransactions.find(g => g.tranche == t);
				giftSources.push(giftSource);
				let consolTranche = {
					tranche: t,
					shareClass: giftSource.shareClass,
					securityType: giftSource.securityType,
					date: Date.now().toString(),
					notes: reason + (giftSource.certNumber ? " Cancellation (" + giftSource.certNumber + ")" : " Cancellation"),
					sender: giftSource.receiver,
					senderName: giftSource.receiverName,
					receiver: "",
					receiverName: "Issuer",
					quantity: giftSource.quantity,
					sharePrice: giftSource.sharePrice
				}
				let consolQty = Number(giftSource.quantity.replace(/[^.\d]/g, ''));
				grossQty += consolQty;
				grossDollars += consolQty * Number(isNaN(giftSource.sharePrice) ? 0 : giftSource.sharePrice.replace(/[^.\d]/g, ''));
				importTransMap.push(consolTranche);
			});

			let reissuance = JSON.parse(JSON.stringify(importTransMap[0]));
			const nextCert = nextCertNum[reissuance.shareClass];
			reissuance.tranche = "NEW";
			reissuance.notes = reason + (nextCert && CERT_COLUMN ? " Reissuance (" + nextCert + ")" : " Reissuance");
			reissuance.receiver = reissuance.sender;
			reissuance.receiverName = reissuance.senderName;
			reissuance.sender = "";
			reissuance.senderName = "Issuer";
			reissuance.quantity = grossQty.toString();
			reissuance.sharePrice = (grossDollars / grossQty).toLocaleString('en-US', m5);

			importTransMap.push(reissuance);
			// incrementNextCertNumber(reissuance.shareClass);
		}

		let headings = ["Tranche","Date","Sender","Receiver","Description","Quantity","Cost Basis"];
		if (CLASS_COLUMN) headings = ["Tranche","Class","Date","Sender","Receiver","Description","Quantity","Cost Basis"];

		if (!importTransMap || !importTransMap.length) {
			importGiftTransferMarkup = `
			<div class="col s12">
				<div class="py-12 bg-grey-lightest border-blue-dotted rounded center-align">
					<p class="max-w-sm mx-auto">No transfer data found.</p>
				</div>
			</div>
			`
		} else {
			rowErrors = new Array(importTransMap.length).fill("");
			importGiftTransferMarkup = `
				<div class="row">
					<div class="col s12">
					<h3 id="importGiftTransferHeading" class="text-lg center-align mb-0 font-bold">Ready for Import</h3>
					</div>
				</div>
				<div class="table-wrap border-grey" style="width: fit-content;">
					<div class="sm-hz-scroll-no-margin">
						<table id="importGiftTransferSortTable" class="highlight table-content">
							<thead>
								<tr>
									${headings.map(h => `
										<th class="text-xs center-align">${h}</th>
										`
										).join('')}
									<th class="text-xs center-align">Status</th>
								</tr>
							</thead>
							<tbody>
							${importTransMap.map((t, i) =>
								`
								<tr class="import-tranche">
									<td>
										<p class="text-xs mb-0 mt-0 center-align">${t.tranche}</p>
									</td>
									${CLASS_COLUMN ? `
									<td>
										<p class="text-xs mb-0 mt-0 center-align">${t.shareClass}</p>
									</td>` : ``}
									<td>
										<p id="editableImportDate-${i}" class="text-xs mb-0 mt-0 center-align" contenteditable>${moment.unix(Number(t.date) / 1000).format("MMM D, YYYY")}</p>
									</td>
									<td>
										<p class="text-xs mb-0 mt-0 center-align">${t.senderName}</p>
									</td>
									<td>
										<p class="text-xs mb-0 mt-0 center-align">${t.receiverName}</p>
									</td>
									<td>
										<p id="editableImportNotes-${i}" class="text-xs mb-0 mt-0 center-align" contenteditable>${t.notes}</p>
										<!-- <p class="text-xs mb-0 mt-0 center-align">${t.pre && t.notes ? (t.pre + ' - ' + t.notes) : t.pre ? t.pre : t.notes}</p> -->
									</td>
									<td>
										<p class="text-xs mb-0 mt-0 center-align">${Number(t.quantity).toLocaleString('en-US', stringOptions)}</p>
									</td>
									<td>
										<p id="editableImportPrice-${i}" class="text-xs mb-0 mt-0 center-align" contenteditable>${!t.sharePrice || isNaN(t.sharePrice) ? 'n.a.' : Number(t.sharePrice?.replace(/[^.\d]/g, '')).toLocaleString('en-US', usp)}</p>
									</td>
									<td id="${'row-' + i}" class="center-align">${dataOkay(t, i) ? greenCheck : redClear}</td>
								</tr>
								`
							).join('')}
							</tbody>
						</table>
					</div>
				</div>
				<div class="flex justify-between items-center">
					<a id="continueEditing" href="#" class="modal-close waves-effect waves-light btn grey mt-6 left">Go Back</a>
	                  <label class="mt-4" title="If checked, cap table (or capital account) balances will be&#10;adjusted according to the allocations. Otherwise the&#10;cap table will remain unchanged." style="transform: scale(0.8);">
	                    <input type="checkbox" id="adjustCapTableAutomatically" checked>
	                    <span style="display:inline-table;">Automatically adjust cap table balances</span>
	                  </label>
					<p class="mr-4 mt-8 text-sm right"><a id="exportGiftTransferMap" href="" download="" target="_blank" rel="noopener noreferrer">Export to Excel</a></p>
					<button id="proceedWithGiftTransferImport" class="right waves-effect waves-light btn mt-6 ml-8 bg-grey-darker">Proceed with Import</button>
				</div>
			`
		}

		let importGiftTransfer = document.getElementById('importGiftTransfer');
		let importGiftTransferTable = document.getElementById('importGiftTransferTable');
		importGiftTransferTable.innerHTML = importGiftTransferMarkup;
		importGiftTransferTable.classList.remove('hidden');

		let proceedWithGiftTransferImport = document.getElementById('proceedWithGiftTransferImport');
		let importGiftTransferHeading = document.getElementById('importGiftTransferHeading');
		let statementWaitState = document.getElementById('statementWaitState');
		let continueEditing = document.getElementById('continueEditing');
		let processHeader = document.getElementById('processHeader');

		function dataOkay (newTrans, index) {
			if (!capTableData) capTableData = NthUtil.sessionStore.readCapTable(client);
			let validUsers = [];
			capTableData.forEach(u => validUsers.push(u.userid));
			badDataCounter++;
			let thisSender = capTableData.find(s => s.userid == newTrans.sender);
			let senderShares = thisSender ? thisSender.clients[client].shares[newTrans.shareClass] : null;
			let senderApproved = senderShares ? senderShares.approved : "0";
			let timeStamp = Number(newTrans.date);
			let types = ['Ordinary Shares','Restricted Shares','RSUs','Profits Interest','SARs','Options','Warrants','Convertibles','Debt','Capital Contribution','Partnership Interest'];
			if (!classes.includes(newTrans.shareClass)) {
				rowErrors[index] = newTrans.shareClass + " is not a Class in Company Profile / Equity.";
				return false;
			}
			if (!types.includes(newTrans.securityType)) {
				rowErrors[index] = newTrans.securityType + " is not a recognized Security Type.";
				return false;
			}
			if (newTrans.strikePrice && newTrans.strikePrice <= 0) {
				rowErrors[index] = newTrans.strikePrice + " is not a valid Strike Price.";
				return false;
			}
			if (newTrans.expDate && newTrans.expDate.toLowerCase() == "invalid date") {
				rowErrors[index] = newTrans.expDate + " is not a valid exp date.";
				return false;
			}
			if (newTrans.date.toLowerCase() == "invalid date" || timeStamp < 0 || timeStamp > 1924992000000) {	// December 31, 2030
				rowErrors[index] = moment.unix(Number(newTrans.date) / 1000).format("MMM D, YYYY") + " is not a valid date.";
				return false;
			}
			if (!validUsers.includes(newTrans.sender) && newTrans.senderName.toLowerCase() != "issuer") {
				rowErrors[index] = newTrans.sender + " is not a valid Sender.";
				return false;
			}
			if (!validUsers.includes(newTrans.receiver) && !["issuer", clientData.company_name.toLowerCase()].includes(newTrans.receiverName.toLowerCase())) {
				rowErrors[index] = newTrans.receiver + " is not a valid Receiver.";
				return false;
			}
			if (Number(newTrans.quantity) <= 0) {
				rowErrors[index] = newTrans.quantity + " is not a valid Quantity.";
				return false;
			}
			// if (thisSender && thisSender.userid.toLowerCase() != "issuer" && Number(senderApproved) < Number(newTrans[7])) {
			// 	rowErrors[index] = newTrans[nmCol] + " exceeds Approved balance.";
			// 	return false;
			// }
			if (Number(newTrans.sharePrice) < 0) {
				rowErrors[index] = newTrans.sharePrice + " is not a valid Cost Basis.";
				return false;
			}
			badDataCounter--;
			return true;
		}

		var num = "zero one two three four five six seven eight nine ten eleven twelve thirteen fourteen fifteen sixteen seventeen eighteen nineteen".split(" ");
		var tens = "twenty thirty forty fifty sixty seventy eighty ninety".split(" ");
		function number2words(n) {
			if (n < 20) return num[n];
			var digit = n%10;
			if (n < 100) return tens[~~(n/10)-2] + (digit? "-" + num[digit]: "");
			if (n < 1000) return num[~~(n/100)] +" hundred" + (n%100 == 0? "": " and " + number2words(n%100));
			return number2words(~~(n/1000)) + " thousand" + (n%1000 != 0? " " + number2words(n%1000): "");
		}

		if (badDataCounter > 0) {
			rowErrors.forEach(function(err, i) {
				if (err.length) document.getElementById('row-' + i).innerHTML = `<span class="material-icons-outlined align-middle" style="color: red; font-size: 30px;" title="${err}">clear</span>`
			});
			importGiftTransferHeading.innerHTML = capitalize(number2words(badDataCounter)) + (badDataCounter > 1 ? " rows have" : " row has") + " bad data.  Please try again.";
			proceedWithGiftTransferImport.classList.add('disabled');
			// return false;
		} else if (importTransMap && importTransMap.length) {
			importGiftTransferHeading.innerHTML = capitalize(number2words(importTransMap.length)) + " Transaction" + (Number(importTransMap.length) > 1 ? "s" : "") + " Ready for Import";
			proceedWithGiftTransferImport.classList.remove('disabled');
		}

		var table = document.getElementById('importGiftTransferSortTable');
		if (table) {
			let sort = new Tablesort(table);
			document.getElementById('exportGiftTransferMap').addEventListener('click', function (e) {
				e.preventDefault();
				export_table_to_excel('importGiftTransferSortTable', "Import Gift Transfer Map (" + new Date().toLocaleString() + ").csv");
			});
		}

		M.Modal.getInstance(viewGiftTransferModal).close();
		M.Modal.getInstance(importGiftTransfer).open();

		document.querySelectorAll('.import-tranche').forEach(tranche => {
			tranche.addEventListener('keyup', function(e) {
				switch(e.target.id.split('-')[0]) {
					case 'editableImportDate': importTransMap[e.target.id.replace('editableImportDate-', '')].date = Date.parse(e.target.innerText).toString(); break;
					case 'editableImportNotes': importTransMap[e.target.id.replace('editableImportNotes-', '')].notes = e.target.innerText; break;
					case 'editableImportPrice': importTransMap[e.target.id.replace('editableImportPrice-', '')].sharePrice = Number(e.target.innerText.replace(/[^-.\d]/g, '')).toLocaleString('en-US', usp); break;
				}
			});
		});

		if (continueEditing) continueEditing.addEventListener('click', function (e) {
			e.preventDefault();
			M.Modal.getInstance(importGiftTransfer).close();
			M.Modal.getInstance(viewGiftTransferModal).open();
		});

		if (proceedWithGiftTransferImport) {
			proceedWithGiftTransferImport.addEventListener('click', async function (e) {
				e.preventDefault();
				M.Modal.getInstance(importGiftTransfer).close();
				M.Modal.getInstance(statementWaitState).open();
				// Wait for axios call completion before continuing
				if (STD_EXT_DATA) complileNewTransactions();
				else importNewTransactions();
			});
		}

		function complileNewTransactions () {
			statementWaitHeader.innerHTML = "Compiling " + importTransMap.length + " new transaction" + (importTransMap.length > 1 ? "s." : ".");
			let dataFileUrl = "https://d333hapirgneg8.cloudfront.net/" + client + "/";
			let dataFile = clientData.transactions_data ? clientData.transactions_data : "";
			if (!dataFile) return;
			else dataFileUrl += dataFile;

			fetch(dataFileUrl).then(function (response) {
				console.log(response);
				return response.text();
			}).then(function (results) {
				// remove header row
				let lines = results.split('\n');
				const certColumn = lines[0].split(',')[3]?.trim().toLowerCase().startsWith("cert");
				lines.splice(0,1);
				results = lines.join('\n');
				modifyCSV(results, certColumn, dataFile);
			}).catch(function (err) {
				console.warn('Something went wrong.', err);
			});

			function csvSafe(str) {
				if (typeof str !== "string") return str;
				return str.includes(',') || str.includes('"') || str.includes('\n')
					? `"${str.replace(/"/g, '""')}"`
					: str;
			}

			async function modifyCSV(results, certColumn, dataFile) {
				console.log(importTransMap);
				let addedCSV = "";
				let adjust = document.getElementById('adjustCapTableAutomatically').checked;

				for (let i = 0; i < importTransMap.length; i++) {
					let r = importTransMap[i];
					let newRow = "";
					let nrid = uuidv4();
					newRow += r.shareClass + ",";
					newRow += moment.unix(Number(r.date) / 1000).format("MMM D YYYY") + ",";
					newRow += r.securityType + ",";

					if (certColumn) {	// External Data source already has a dedicated Certificate column
						let certNumber = getCertNumber(r.notes);
						newRow += (certNumber ? certNumber[2] : "0") + ",";
					}

					newRow += csvSafe(r.notes) + ",";
					// newRow += (r.pre && r.notes ? (r.pre + ' - ' + r.notes) : r.pre ? r.pre : r.notes) + ",";
					newRow += nrid + ",";
					newRow += csvSafe(r.senderName) + ",";
					newRow += r.sender + ",";
					newRow += csvSafe(r.receiverName) + ",";
					newRow += r.receiver + ",";
					newRow += r.quantity + ",";
					// newRow += Number(r.sharePrice.replace(/[^.\d]/g, '')).toLocaleString('en-US', usp) + ",";
					// newRow += csvSafe(r.sharePrice) + "\r\n";
					let clean = (r.sharePrice || "").trim().toLowerCase();
					let isNA = clean === "" || clean === "n.a." || clean === "na";
					if (isNA) {
						newRow += "n.a.,";
						newRow += "n.a.\r\n";
					} else {
						let formatted = Number(r.sharePrice.replace(/[^.\d]/g, '')).toLocaleString('en-US', usp);
						newRow += formatted + ",";
						newRow += csvSafe(r.sharePrice) + "\r\n";
					}
					addedCSV += newRow;

					if (adjust) {
						let adjustParams = {
							shareClass: r.shareClass,
							quantity: r.quantity,
							senderId: r.sender,
							receiverId: r.receiver
						};
						await adjustCapTable(adjustParams);
					}
				}

				let rows = results.split('\n');
				giftSources.forEach(s => {
					for (let i = 0; i < rows.length; i++) {
						if (rows[i].includes(s.nrid)) {
							let fields = rows[i].split(',');
							fields[3] = fields[3].replace('#', '');
							fields[4] = fields[4].replace('#', '');
							rows[i] = fields.join(',');
							break;
						}
					}
				});
				results = rows.join('\n');
				// transaction map schema
				// date: "1671033286002", notes: "1/3/1994 From ERN Jr.", pre: "werw", quantity: "975", receiver: "amywilsonhale+enw_grat@gmail.com", receiverName: "EN Wilson Grat Dtd July 2008 AWH", securityType: "Ordinary Shares", sender: "amywilsonhale@gmail.com", senderName: "Amy W Hale Revocable Trust", shareClass: "C", sharePrice: "1.48", tranche: "A"
				let header = "Class,Date,Security Type,Description,nrid,Sender,Sender Email,Receiver,Receiver Email,Quantity,Cost Basis,Exact Cost,Reference Cost,Qty * Exact Cost, Qty * Ref. Cost,Strike Price,Expiration Date\r\n";
				if (certColumn) header = "Class,Date,Security Type,Cert#,Description,nrid,Sender,Sender Email,Receiver,Receiver Email,Quantity,Cost Basis,Exact Cost,Reference Cost,Qty * Exact Cost, Qty * Ref. Cost,Strike Price,Expiration Date\r\n";

				let newResults = header + addedCSV + results;
				uploadCSV(newResults);
				incrementNextCertNumber(giftSources[0].shareClass);
			}

			function uploadCSV (file) {
				// send file to S3 bucket
				console.log(Date.now());
				if (clientData.transactions_data) {
					console.log(clientData.transactions_data.substring(13,99));
					sendToS3(Date.now() + clientData.transactions_data.substring(13,99));			// <-- CATCH 22 must be "seeded" in DynamoDB
				} else {
					sendToS3(Date.now() + "_" + client + "_transactions.csv");
				}

				function sendToS3 (awsFileToUpload) {
					axios.get(authUploadUrl,{
						params: {
							filename: client + "/" + awsFileToUpload,
							bucket: "reports.nthround.io",
							client: client,
							userid: authedUser,
							cookie: cookie
						}
					})
					.then(function(res1){
						//console.log(res1);
						let formData = secureFormData(res1);
						formData.append("file", file);
						axios.post(res1.data.url, formData, axconf)
						.then(function (res2) {
							console.log("DataSource update response: ", res2);
							let dataToUpdate = {transactions_data: awsFileToUpload};
							clientData.transactions_data = awsFileToUpload;
							console.log("dataToUpdate:", dataToUpdate);
							sendData(dataToUpdate, 'transactions-data', true);

							if (window.analytics) window.analytics.track('DataSource Updated', {
								userEmail: authedUser,
								workspace: client,
								dataSourceName: awsFileToUpload
							});
						})
						.catch(function (err2) {
							console.error(err2);
						});
					})
					.catch(function(err1){
						console.error(err1);
					});
				}
			}

			function sendData (params, api, toast) {
				sessionStorage.setItem(client + '.Data', JSON.stringify(clientData));
				let apiUrl = 'https://api.nthround.io/portal/clientConfig/' + api;
				params.client = client;
				params.userid = authedUser;
				params.cookie = cookie;
				axios.put(apiUrl, {
					body: "body"}, {
						params
				})
				.then(function (response) {
					console.log(response);
					clearPendingRequests("Processed");
				})
				.catch(function (error) {
					console.error(error);
				});
			}
		}

		async function importNewTransactions() {
			statementWaitHeader.innerHTML = "Importing " + importTransMap.length + " new transaction" + (importTransMap.length > 1 ? "s." : ".");

			// Import transactions sequentially
			for (let i = 0; i < importTransMap.length; i++) {
				await createNewTransaction(transParams(importTransMap[i]), false);
			}

			console.log("Finished importing transactions.");

			// Process gift sources sequentially
			for (let i = 0; i < giftSources.length; i++) {
				let patchParams = {
					class_name: giftSources[i].shareClass,
					date: giftSources[i].date.toString(),
					quantity: giftSources[i].quantity,
					sender_id: giftSources[i].sender,
					sender_name: giftSources[i].senderName,
					receiver_id: giftSources[i].receiver,
					receiver_name: giftSources[i].receiverName,
					share_price: giftSources[i].sharePrice,
					security_type: giftSources[i].securityType,
					nrid: giftSources[i].nrid,
					notes: giftSources[i].notes.replace('#', ''),
					// expDate: giftSources[i].expDate,
					// strike_price: giftSources[i].strike_price,
					userid: authedUser,
					cookie: cookie,
					client: client
				};

				try {
					const res = await axios.patch(urlTransactions, { body: "body" }, { params: patchParams });
					console.log(res);
				} catch (err) {
					console.error(err);
				}
			}

			document.dispatchEvent(new Event('RefreshSessionStorage'));
			console.log("Completed processing gift sources.");
			if (CERT_COLUMN) incrementNextCertNumber(giftSources[0]?.shareClass);
		}

		// Transaction parameters helper
		function transParams(row) {
			return {
				shareClass: row.shareClass,
				securityType: row.securityType,
				date: (Number(row.date) / 1000).toFixed(0),
				description: row.notes,
				sender: row.sender,
				receiver: row.receiver,
				senderName: row.senderName,
				receiverName: row.receiverName,
				quantity: row.quantity,
				sharePrice: row.sharePrice
			};
		}

		// Updated createNewTransaction to support async/await
		async function createNewTransaction(transParams, isJustOne) {
			if (!isJustOne) importTransCounter++;
			let date = DOMPurify.sanitize(transParams.date);
			let expDate = DOMPurify.sanitize(transParams.expDate);
			let description = DOMPurify.sanitize(transParams.description);
			let shareClass = DOMPurify.sanitize(transParams.shareClass);
			let securityType = DOMPurify.sanitize(transParams.securityType);
			let strikePrice = DOMPurify.sanitize(transParams.strikePrice);
			let sharePrice = DOMPurify.sanitize(transParams.sharePrice);
			let quantity = DOMPurify.sanitize(transParams.quantity);
			let sender = DOMPurify.sanitize(transParams.sender);
			let receiver = DOMPurify.sanitize(transParams.receiver);
			let senderId = DOMPurify.sanitize("");
			let receiverId = DOMPurify.sanitize("");
			let senderName = DOMPurify.sanitize(transParams.senderName);
			let receiverName = DOMPurify.sanitize(transParams.receiverName);

			if (sender.startsWith("Issuer")) {
				receiverId = receiver;
				senderName = "Issuer";
			} else if (receiver.startsWith("Issuer")) {
				senderId = sender;
				receiverName = "Issuer";
			} else {
				senderId = sender;
				receiverId = receiver;
			}

			if (document.getElementById('adjustCapTableAutomatically').checked) {
				await adjustCapTable({
					shareClass: shareClass,
					quantity: quantity,
					senderId: senderId,
					receiverId: receiverId
				});
			}

			try {
				const res = await axios.put(urlTransactions, {
					body: "body"
				}, {
					params: {
						userid: authedUser,
						cookie: cookie,
						client: client,
						class_name: shareClass,
						date: date,
						expDate: expDate,
						notes: description,
						security_type: securityType,
						strike_price: strikePrice,
						share_price: sharePrice,
						quantity: quantity,
						sender_id: senderId,
						receiver_id: receiverId,
						sender_name: senderName,
						receiver_name: receiverName
					}
				});

				let newTransaction = {
					date: date,
					expDate: expDate,
					notes: description,
					securityType: securityType,
					shareClass: shareClass,
					strikePrice: strikePrice,
					sharePrice: sharePrice,
					quantity: quantity,
					sender: senderId,
					receiver: receiverId,
					senderName: senderName,
					receiverName: receiverName,
					nrid: res.data.nrid
				};

				if (!clientData.equity[shareClass].transactions) clientData.equity[shareClass].transactions = [];
				clientData.equity[shareClass].transactions.push(newTransaction);
				sessionStorage.setItem(client + '.Data', JSON.stringify(clientData));

				if (!isJustOne && importTransCounter >= importTransTarget) {
					clearPendingRequests("Processed");
				}
			} catch (err) {
				console.error(err);
			}

			// if (isJustOne) M.Modal.getInstance(statementWaitState).close();
		}

		async function adjustCapTable (adjustParams) {
			let shareAmount = Number(adjustParams.quantity);
			if (!shareholderData) shareholderData = JSON.parse(sessionStorage.getItem('shareholder.Data'));
			if (!capTableData) capTableData = NthUtil.sessionStore.readCapTable(client);
			if (!capTableData || !shareholderData) return;
			if (adjustParams.senderId && adjustParams.senderId.includes("@")) {
				let senderOwned = 0;
				let senderApproved = 0;
				let senderIndex = capTableData.findIndex(x => x.userid == adjustParams.senderId);
				let senderClient = capTableData[senderIndex].clients[client];
				if (senderClient) {
					let senderClass = senderClient.shares[adjustParams.shareClass];
					if (senderClass && Number(senderClass.owned) >= shareAmount && Number(senderClass.approved) >= shareAmount) {
						let senderOwned = Number(senderClass.owned);
						let senderApproved = Number(senderClass.approved);
						// senderOwned -= shareAmount;
						// senderApproved -= shareAmount;

						// PRECISION LOGIC
						// per-client precision (4 or 6, etc.)
						const SCALE = 3;
						const EPS = 0.5 * (10 ** (-SCALE)); // half-ULP at that scale
						// zero-aware subtract (one-liner)
						const sub = (x, y) => Math.abs(x - y) <= EPS ? 0 : (x - y);
						senderOwned = sub(senderOwned, shareAmount);
						senderApproved = sub(senderApproved, shareAmount);

						shareholderData.clients[client].shares[adjustParams.shareClass].owned = senderOwned.toString();
						shareholderData.clients[client].shares[adjustParams.shareClass].approved = senderApproved.toString();
						capTableData[senderIndex].clients[client].shares[adjustParams.shareClass].owned = senderOwned.toString();
						capTableData[senderIndex].clients[client].shares[adjustParams.shareClass].approved = senderApproved.toString();
						sessionStorage.setItem('shareholder.Data', JSON.stringify(shareholderData));
						NthUtil.sessionStore.updateCapTable(client, capTableData);
						await axios.post('https://api.nthround.io/portal/user/update-user-client-data',
							JSON.stringify({
								client: client,
								userid: authedUser,
								cookie: cookie, 
								holder: adjustParams.senderId,
								data: capTableData[senderIndex].clients[client]
							})
						)
					} else {
						// abort
					}
				}
			}
			if (adjustParams.receiverId && adjustParams.receiverId.includes("@")) {
				let receiverOwned = 0;
				let receiverApproved = 0;
				let receiverIndex = capTableData.findIndex(x => x.userid == adjustParams.receiverId);
				let receiverClient = capTableData[receiverIndex].clients[client];
				if (receiverClient) {
					let receiverClass = receiverClient.shares[adjustParams.shareClass];
					if (receiverClass) {
						receiverOwned = Number(receiverClass.owned);
						receiverApproved = Number(receiverClass.approved);
					} else {
						let newSharesObj = {
							owned: "0",
							approved: "0",
							committed: "0",
							permitPurchase: true
						}
						capTableData[receiverIndex].clients[client].shares[adjustParams.shareClass] = newSharesObj;
					}
					let itsClose = (Math.abs(receiverOwned - receiverApproved) * 200 / (receiverOwned + receiverApproved)) < 1 ? true : false;
					if (receiverOwned + receiverApproved < 0.00001) itsClose = true;
					receiverOwned += shareAmount;
					if (itsClose) receiverApproved += shareAmount;

					// added 12-17-2024 (not sure we need the test, but it can't hurt)
					if (adjustParams.receiverId == shareholderData.userid) {
						shareholderData.clients[client].shares[adjustParams.shareClass].owned = receiverOwned.toString();
						shareholderData.clients[client].shares[adjustParams.shareClass].approved = receiverApproved.toString();
						sessionStorage.setItem('shareholder.Data', JSON.stringify(shareholderData));
					}

					capTableData[receiverIndex].clients[client].shares[adjustParams.shareClass].owned = receiverOwned.toString();
					capTableData[receiverIndex].clients[client].shares[adjustParams.shareClass].approved = receiverApproved.toString();
					NthUtil.sessionStore.updateCapTable(client, capTableData);
					await axios.post('https://api.nthround.io/portal/user/update-user-client-data',
						JSON.stringify({
							client: client,
							userid: authedUser,
							cookie: cookie, 
							holder: adjustParams.receiverId,
							data: capTableData[receiverIndex].clients[client]
						})
					)
				}
			}
		}
	}

	async function clearPendingRequests (newStatus) {
		// Get transfer requests for this user
		let requests = shareholderData.clients[client].transfer_requests;
		if (requests && Object.keys(requests).length > 0) {
			statementWaitHeader.innerHTML = "Your browser will refresh. Stand by...";
			
			// Update all "Open" gifts' status to "Processed"
			Object.values(requests).flat().forEach(gift => {
				if (gift.status === "Open") gift.status = newStatus;
			});

			// Save updated data
			sessionStorage.setItem('shareholder.Data', JSON.stringify(shareholderData));

			try {
				const response = await axios.post(
					'https://api.nthround.io/portal/user/update-user-client-data',
					JSON.stringify({
						client: client,
						userid: authedUser,
						cookie: cookie,
						holder: shareholder,
						data: shareholderData.clients[client]
					})
				);
				console.log(response);
				showToast("success-toast", "Data updated successfully!");
				document.dispatchEvent(new Event('RefreshSessionStorage'));
				setTimeout(() => {
					M.Modal.getInstance(statementWaitState).close();
					location.reload();
				}, 5000);
			} catch (error) {
				console.error(error);
			}
		} else {
			showToast("success-toast", "Data updated successfully!");
			document.dispatchEvent(new Event('RefreshSessionStorage'));
			M.Modal.getInstance(statementWaitState).close();
			document.dispatchEvent(new CustomEvent('renderShareholderView', { detail: {"shareholder": shareholder, "refreshed": true }}));
		}
	}

	function sendThisRequest () {
		let timestamp = Date.now().toString();
		const waitingModal = document.getElementById('waitingModal');
		M.Modal.getInstance(viewGiftTransferModal).close();
		M.Modal.getInstance(waitingModal).open();
		// previewGiftTransfer.classList.add('disabled');
		// previewGiftTransfer.innerHTML = "One moment please...";
		let purpose = BUY_BACK ? labelBB + " Request" : "Share Transfer Request";
		let giftHtml = giftHeadline.innerHTML + '<br>' + balanceHeadline.innerHTML.replace('Shares Owned Now:', 'Shares Owned:') + '<br>' + userGiftTransferTable.innerHTML + '<br>' + totalCurrentValueDiv.innerHTML + '<br>' + viewRecipients.innerHTML;
		giftHtml = cleanAndFormatHtml(giftHtml);

		function cleanAndFormatHtml(giftHtml) {
			// Parse the raw HTML into a DOM object
			const parser = new DOMParser();
			const doc = parser.parseFromString(giftHtml, "text/html");

			// Add professional heading at the top
			const headingDiv = document.createElement("div");
			const today = new Date().toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" });
			headingDiv.innerHTML = `
				<h1 style="text-align: center; font-size: 20px; color: #2c3e50; margin: 34px 0 5px;">${purpose}</h1>
				<div style="text-align: center; font-size: 14px; color: #555; margin: 0 0 20px;">Made on ${today} by ${userData.user_name}</div>
			`;

			doc.getElementById('showHidePriorsDiv')?.remove();

			// Inject the heading before the content
			const body = doc.body;
			body.insertBefore(headingDiv, body.firstChild);

			// Remove all hidden elements
			doc.querySelectorAll(".hidden, [style*='display: none']").forEach((el) => el.remove());

			// Remove "Remove" buttons
			doc.querySelectorAll(".remove-gift-recipient").forEach((el) => el.remove());

			// Remove checkboxes but retain the "Tranche" designation
			doc.querySelectorAll("input[type='checkbox']").forEach((checkbox) => {
				const td = checkbox.closest("td");
				if (td) {
					const trancheDesignation = td.querySelector("div.shareholder-img");
					if (trancheDesignation) {
						td.innerHTML = trancheDesignation.outerHTML; // Keep the tranche designation
					} else {
						td.innerHTML = ""; // Replace with empty content if no designation exists
					}
				}
			});


			// Add professional styles
			const style = `
				<style>
					body {
						font-family: 'Source Sans Pro', sans-serif;
						font-size: 12px;
						margin: 1in;
					}
					h1, h2, h5 {
						color: #2c3e50;
						text-align: center;
						margin: 0.1in 0 0.1in;
					}
					.table-heading {
						background-color: #2c3e50;
						color: white;
						font-weight: bold;
						text-align: center;
						padding: 4px;
						font-size: 12px; /* Larger heading size */
					}
					table {
						width: 100%;
						border-collapse: collapse;
						margin: 0.1in 0;
					}
					th, td {
						border: 1px solid #ddd;
						text-align: center;
						padding: 4px;
						font-size: 12px; /* Table font size remains consistent */
					}
					th {
						background-color: #f4f4f4;
						font-weight: bold;
						font-size: 13px; /* Slightly larger than table rows */
					}
					strong {
						font-weight: bold;
						font-size: 14px; /* Larger font size for names */
					}
					.ownership {
						font-weight: bold;
						font-size: 14px; /* Match label size for numerals */
						color: #555;
					}
					.recip-div {
						margin-top: 0.2in; /* Add vertical spacing between recipient sections */
					}
				</style>
			`;

			// Inject the styles into the document head
			const styleElement = document.createElement("style");
			styleElement.innerHTML = style;
			doc.head.appendChild(styleElement);

			// Add "To: " before each recipient's name and ensure font size matches sender's name
			doc.querySelectorAll(".recip-div .row .col.s12.m6").forEach((el) => {
				el.innerHTML = `To: <strong>${el.textContent.trim()}</strong>`;
				el.querySelector("strong").style.fontSize = "14px"; // Larger size for names
			});

			// Make sender's name bold and ensure proper size
			const senderElement = doc.querySelector("span.text-light");
			if (senderElement) {
				senderElement.innerHTML = `<strong>${senderElement.textContent.trim()}</strong>`;
				senderElement.querySelector("strong").style.fontSize = "14px"; // Match recipient font size
			}

			// Ensure before/after ownership numerals match label size
			doc.querySelectorAll(".text-primary").forEach((el) => {
				el.style.fontSize = "14px"; // Match the subheading labels
				el.style.fontWeight = "bold"; // Ensure boldness
				el.style.color = "#555"; // Consistent coloring
			});

			// Remove empty rows at the bottom of each recipient's section
			doc.querySelectorAll(".recip-div table tbody").forEach((tbody) => {
				const rows = Array.from(tbody.querySelectorAll("tr"));
				rows.forEach((row) => {
					const isEmptyRow = Array.from(row.cells).every(
						(cell) => !cell.textContent.trim()
					);
					if (isEmptyRow) row.remove();
				});
			});

			// Reduce vertical spacing for p, .row, and tables
			doc.querySelectorAll("p, .row, table").forEach((el) => {
				el.style.marginTop = "0.1in";
				el.style.marginBottom = "0.1in";
			});

			// Return the cleaned and formatted HTML as a string
			return doc.documentElement.outerHTML;
		}

		const giftString = JSON.stringify(theseGifts);
		const giftBlob = new Blob([JSON.stringify(theseGifts)], { type: 'application/json' });
		const giftFile = new File([giftBlob], purpose.replace(/ /g, '_') + "_from_" + userData.userid + ".json", { type: "application/json" });

		uploadGiftRequestToYourDocs();

		async function uploadGiftRequestToYourDocs() {
			// Prepare new document to be added to the user's documents
			let newDoc = {
				type: "Call/Notice",
				tag: "ALL",
				name: purpose,
				investor: userData.userid,
				description: "From " + userData.user_name,
				require2Factor: false,
				date: moment().format("MMM D, YYYY"),
				id: timestamp,
			};

			// Prepare parameters for the document upload API
			let params = {
				...newDoc,
				client: client,
				userid: authedUser,
				cookie: cookie,
				htmlResults: giftHtml,
				callOrigin: 'gift-transfer'
			};

			// Add transfer_request to User json
			let userTransferRequests = userData.clients[client].transfer_requests || {};

			// Initialize an array for the timestamp if not present
			userTransferRequests[timestamp] = userTransferRequests[timestamp] || [];

			// Push all gifts into the transfer_requests, each with a status
			allGifts.forEach(gift => {
				userTransferRequests[timestamp].push({ ...gift, status: "Open" });
			});

			// Update the userData object and save it to session storage
			userData.clients[client].transfer_requests = userTransferRequests;
			sessionStorage.setItem("user.Data", JSON.stringify(userData));

			// Prepare the payload for the DynamoDB update API
			let dynamoDbPayload = {
				userid: authedUser,
				client: client,
				cookie: cookie,
				holder: userData.userid,
				data: userData.clients[client]
			};

			// Call both APIs sequentially
			try {
				// 1. Update transfer_requests in DynamoDB
				const dynamoRes = await axios.post("https://api.nthround.io/portal/user/update-user-client-data", JSON.stringify(dynamoDbPayload));
				console.log("DynamoDB update response:", dynamoRes);
				
				// 2. Upload the document
				const docRes = await axios.post("https://api.nthround.io/portal/auth/upload-to-your-docs", params);
				console.log("upload-to-your-docs response:", docRes);
				sendGiftRequestEmail(docRes.data.pdf_url);

				// If both succeed
				console.log("Transfer Request successfully uploaded and transfer_requests updated.");

				let holder = userData.userid;	// preview breadcrumb
				document.dispatchEvent(new Event('RefreshSessionStorage'));
				setTimeout(() => {
					M.Modal.getInstance(waitingModal).close();
					M.Modal.getInstance(leaveMessageModal).open();
					// previewGiftTransfer.classList.remove('disabled');
					// previewGiftTransfer.innerHTML = "Request These Transfers";

					M.Modal.getInstance(leaveMessageModal).options.onCloseEnd = () => {
						if (sessionStorage.getItem('preview'))
							document.dispatchEvent(new CustomEvent('previewShareholder', { detail: {"uid": holder, "path": '' }}));
						else document.dispatchEvent(new Event('renderInvestorPortal'));						
					};
				}, 2000);
			} catch (err) {
				// Log any errors from either API call
				console.error("Error during transfer request processing:", err);
			}
		}

		function sendGiftRequestEmail (pdfUrl) {
			const ending = `<br><br>${firstName(userData)}<br><br><a href="https://${client}.nthround.io/admin/users/edit/?email=${userData.userid}">View this ${purpose}</a>`
			axios.post('https://api.nthround.io/portal/auth/send-email',
				JSON.stringify({
					client: client,
					userid: authedUser,
					cookie: cookie,
					sender_email: "messages@nthround.com",
					sender_name: userData.user_name,
					replyto_email: userData.userid,
					recipient: clientData.contact_email,
					cc_emails: [userData.userid],
					subject: purpose,
					message: "Hi--<br><br>Please review this " + purpose + ".<br><br>I understand that you will reach out to me for confirmation prior to processing.<br><br>Thank you!" + ending + "<br><br>[Note: email replies will go to " + userData.user_name + " &lt;" + userData.userid + "&gt;.]",
					attachment: pdfUrl
				})
			)
			.then(function(res) {
				const btnGroupLink = document.getElementById('btnGroupLink');
				const leaveMessageLink = document.getElementById('leaveMessageLink');
				const leaveMessageModal = document.getElementById('leaveMessageModal');
				leaveMessageLink.classList.add('disabled');
				leaveMessageLink.innerHTML = purpose + " Pending";
				btnGroupLink.classList.replace('bg-grey-darker', 'grey');
				leaveMessageModal.innerHTML = `
					<div class="p-2 center-align">
						<div class="mb-4"><img src="./../../resources/assets/celebrate-v4.svg" alt="Musicians celebrating" class="responsive-img px-12"/></div>
						<h3 class="text-lg mb-4 mt-4 font-bold">Your request has been sent!</h3>
						<p class="text-secondary text-sm mt-0 mb-0">We emailed a copy to ${userData.userid}.</p>
						<p class="text-secondary text-sm mt-0 mb-0">The company will reach out shortly to confirm your request.</p>
						<p class="text-secondary text-xs mt-0 mb-0">(On closing this modal your browser will refresh.)</p>
					</div>
				`
			})
			.catch(function(err) {
				console.error(err);
			});
		}
	}

	function toNumber(str) {
		var num = Number(str);
		return isNaN(num) ? 1 : num;	// assumed share price, zero is trouble mathwise!
	}

	function numberToLetters (num) {
		let letters = ''
		while (num >= 0) {
			letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'[num % 26] + letters
			num = Math.floor(num / 26) - 1
		}
		return letters
	}

	function lettersToNumbers (ltrs) {
		if (!ltrs) return '?';
		for (var p = 0, n = 0; p < ltrs.length; p++){
			n = ltrs[p].charCodeAt() - 64 + n * 26;
		}
		return n;
	}

	function initModal () {
	}

	// Reinitialize M.Modal to include dynamically added instances
	// var modals = document.querySelectorAll('.modal');
	// let modalOptions = { onOpenStart: initModal };
	// var instances = M.Modal.init(modals, modalOptions);
}

export {giftTransfer};